//-----------------------轴线命名处理
import {
  getrlFloor,
  getrlStdFlr,
  updateBulkRlStdFlrFieldDatas,
  getRlBeamSect,
  getRlWallHoleDef,
} from "@/mixins/LiteModuleDb.js";

import mxcad from "mxcad";
const {
  McDbLine,
  McCmColor,
  McDbText,
  McGePoint3d,
  McDbCircle,
  McDbPolyline,
  MxCADResbuf,
  McDbArc,
  MxCpp,
} = mxcad;
import {
  select_entiy_get,
  ptOnLine,
  ptOnArc,
  getSelectEntity,
  ptIsEqual,
} from "./operateApi.js";
// 全局loading
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";
import { calculateParallelLineDistance } from "./GraphicDataCal.js";

import {
  calculateArcAngle,
  normalizeAngle,
  toDegrees,
} from "@/rlMxModules/operate/GraphicDataCal.js";
import store from "@/store";
import { login } from "@/api/user.js";
import { forEach } from "jszip";
//清空所有轴线命名
export const clearAllAxisNaming = async () => {
  //将当前显示的轴线文字更新
  if (allShowAxisData) {
    for (const key in allShowAxisData) {
      const axisArrayData = allShowAxisData[key];
      if (axisArrayData.length === 0) {
        continue; //跳过没有轴线的楼层
      }
      //更新轴线文字
      axisArrayData.forEach((axis) => {
        axis.axisData.Name = "";
        axis.textMcDbId1.getMcDbEntity().textString = "";
        axis.textMcDbId2.getMcDbEntity().textString = "";
      });
    }
  }

  //获取所有楼层
  let rlTotalFloor = await getrlFloor();
  //遍历楼层，获取所有轴线，清空命名字段
  for (const floor of rlTotalFloor) {
    // 获取当前楼层底标高
    let floorModelData = await getrlStdFlr(floor.StdFlrGuid);
    let updateObjs = {};
    if (floorModelData && floorModelData["rlAxis"]) {
      updateObjs["rlAxis"] = [];

      Object.keys(floorModelData["rlAxis"]).forEach((key) => {
        floorModelData["rlAxis"][key].Name = "";
        updateObjs["rlAxis"].push(floorModelData["rlAxis"][key]);
      });
    }

    // 获取当前楼层所有墙
    if (floorModelData && floorModelData["rlWallSeg"]) {
      updateObjs["rlWallSeg"] = [];

      Object.keys(floorModelData["rlWallSeg"]).forEach((key) => {
        floorModelData["rlWallSeg"][key].ModelNo = "";
        updateObjs["rlWallSeg"].push(floorModelData["rlWallSeg"][key]);
      });
    }

    // 获取当前楼层所有梁
    if (floorModelData && floorModelData["rlBeamSeg"]) {
      updateObjs["rlBeamSeg"] = [];

      Object.keys(floorModelData["rlBeamSeg"]).forEach((key) => {
        floorModelData["rlBeamSeg"][key].ModelNo = "";
        let otherData = floorModelData["rlBeamSeg"][key].OtherData;
        if (otherData && typeof otherData == "string") {
          otherData = JSON.parse(otherData);
        }
        //重复校验一次
        if (otherData && typeof otherData == "string") {
          otherData = JSON.parse(otherData);
        }
        if (otherData && typeof otherData == "object") {
          otherData.sameModelEnts = [];
        }

        updateObjs["rlBeamSeg"].push(floorModelData["rlBeamSeg"][key]);
      });
    }

    // 获取当前楼层所有柱子
    if (floorModelData && floorModelData["rlColSeg"]) {
      updateObjs["rlColSeg"] = [];

      Object.keys(floorModelData["rlColSeg"]).forEach((key) => {
        floorModelData["rlColSeg"][key].ModelNo = "";
        updateObjs["rlColSeg"].push(floorModelData["rlColSeg"][key]);
      });
    }

    // 获取当前楼层所有楼板
    if (floorModelData && floorModelData["rlSlab"]) {
      updateObjs["rlSlab"] = [];

      Object.keys(floorModelData["rlSlab"]).forEach((key) => {
        floorModelData["rlSlab"][key].ModelNo = "";
        updateObjs["rlSlab"].push(floorModelData["rlSlab"][key]);
      });
    }

    //逐层保存
    await updateBulkRlStdFlrFieldDatas(floor.StdFlrGuid, updateObjs);
  }
};

//记录绘制的轴线数据
let totalDrawingData = [];
let allShowAxisData = {}; //轴线数据
let allShowArcAxisData = {}; //弧形轴线数据
let isExistManualAxisNaming = false; //是否存在手动命名轴线

//显示所有基准层轴网和构件数据
export const showAllBaseFloorData = async (baseFloorDatas /*基准层ids */) => {
  //获取基准层所有轴线，柱子，墙，梁
  const {
    totalAxisData,
    totalArcAxisData,
    totalColumnData,
    totalWallData,
    totalBeamData,
  } = await getBaseFloorData(baseFloorDatas);
  console.log("totalAxisData", totalAxisData);

  //记录不重复的轴线数据
  let uniqueAxisArrayData = {};
  for (const key in totalAxisData) {
    let axisData = totalAxisData[key];
    // console.log('key',key);

    //同一斜率下distance相同即为共线，同一组数据中取C值更大的数据保留
    let uniqueAxisData = {};
    for (const item of axisData) {
      if (
        Math.abs(item.pt1.x - item.pt2.x) < 0.1 &&
        Math.abs(item.pt1.y - item.pt2.y) < 0.1
      ) {
        continue;
      }
      if (item.axisData.IsMainAxis < 0) continue;

      if (!uniqueAxisData[item.distance]) {
        uniqueAxisData[item.distance] = item;
      } else {
        //取主轴线,主轴属性按照最高级别保留
        let axisMainType = 0;
        if (
          uniqueAxisData[item.distance].axisData.IsMainAxis == 1 ||
          item.axisData.IsMainAxis == 1
        ) {
          axisMainType = 1;
        } else {
          axisMainType =
            item.axisData.IsMainAxis >
            uniqueAxisData[item.distance].axisData.IsMainAxis
              ? item.axisData.IsMainAxis
              : uniqueAxisData[item.distance].axisData.IsMainAxis;
        }

        if (Number(item.C) > Number(uniqueAxisData[item.distance].C)) {
          uniqueAxisData[item.distance] = item;
          uniqueAxisData[item.distance].axisData.IsMainAxis = axisMainType;
        } else {
          const currentData = uniqueAxisData[item.distance];
          const pt1 = new THREE.Vector3(
            currentData.pt1.x,
            currentData.pt1.y,
            0
          );
          const pt2 = new THREE.Vector3(
            currentData.pt2.x,
            currentData.pt2.y,
            0
          );
          const pt1_1 = new THREE.Vector3(item.pt1.x, item.pt1.y, 0);
          const pt2_1 = new THREE.Vector3(item.pt2.x, item.pt2.y, 0);
          if (
            (ptIsEqual(pt1, pt1_1) && ptIsEqual(pt2, pt2_1)) ||
            (ptIsEqual(pt2, pt1_1) && ptIsEqual(pt1, pt2_1))
          ) {
          } else {
            const points = [pt1, pt2, pt1_1, pt2_1];
            const sortPoints = sortCollinearPoints(points);
            uniqueAxisData[item.distance].pt1 = sortPoints[0];
            uniqueAxisData[item.distance].pt2 =
              sortPoints[sortPoints.length - 1];
          }
          uniqueAxisData[item.distance].axisData.IsMainAxis = axisMainType;
        }
      }
    }
    //按距离排序
    uniqueAxisData = Object.values(uniqueAxisData).sort(
      (a, b) => a.distance - b.distance
    );

    uniqueAxisArrayData[key] = uniqueAxisData;
  }
  console.log("uniqueAxisArrayData", uniqueAxisArrayData);

  allShowAxisData = drawAxisDrawingData(uniqueAxisArrayData);
  allShowArcAxisData = drawArcAxisDrawingData(totalArcAxisData);
  drawModelDrawingData(totalColumnData, totalWallData, totalBeamData);
};

//获取所有基准层数据
const getBaseFloorData = async (baseFloorDatas) => {
  let totalAxisData = {}; //轴线数据
  let totalArcAxisData = []; //弧形轴线数据
  let totalColumnData = {}; //柱子数据
  let totalWallData = {}; //墙数据
  let totalBeamData = {}; //梁数据
  for (const floorData of baseFloorDatas) {
    let floorModelData = await getrlStdFlr(floorData.StdFlrGuid);

    //记录主轴线数据
    let mainAxisDatas = [];
    //记录主轴上的节点数据
    let jointOnMainAxis = [];
    //记录辅轴线数据
    let subAxisDatas = [];
    //获取基准层所有柱子
    if (
      floorModelData &&
      floorModelData["rlColSeg"] &&
      floorModelData["rlJoint"]
    ) {
      const jointDatas = floorModelData["rlJoint"];
      const columnDatas = floorModelData["rlColSeg"];
      for (const key in columnDatas) {
        //记录柱子数据
        const jointObj = jointDatas[columnDatas[key].JtGuid];
        if (jointObj) {
          //获取柱子位置
          const position =
            Math.round(jointObj.X) + "," + Math.round(jointObj.Y);
          //记录柱子数据,同一位置，只记录一个
          if (!totalColumnData[position])
            totalColumnData[position] = columnDatas[key];

          //记录主轴上的节点数据
          jointOnMainAxis.push({
            x: jointObj.X,
            y: jointObj.Y,
          });
        }
      }
    }

    //获取基准层所有的墙
    if (
      floorModelData &&
      floorModelData["rlWallSeg"] &&
      floorModelData["rlJoint"] &&
      floorModelData["rlGrid"]
    ) {
      const jointDatas = floorModelData["rlJoint"];
      const wallDatas = floorModelData["rlWallSeg"];
      const gridDatas = floorModelData["rlGrid"];
      for (const key in wallDatas) {
        //获取墙的网格
        const gridGuid = wallDatas[key].GridGuid;
        const grid = gridGuid ? gridDatas[gridGuid] : null;
        if (grid) {
          //计算网格位置
          const joint_1 = jointDatas[grid.Jt1Guid];
          const joint_2 = jointDatas[grid.Jt2Guid];
          if (!joint_1 || !joint_2) {
            continue;
          }
          //记录墙数据
          //坐标取整
          const position =
            Math.round(joint_1.X) +
            "," +
            Math.round(joint_1.Y) +
            "," +
            Math.round(joint_2.X) +
            "," +
            Math.round(joint_2.Y);
          if (!totalWallData[position])
            totalWallData[position] = wallDatas[key];

          //记录主轴线数据
          if (!mainAxisDatas.includes(grid.AxisGuid)) {
            mainAxisDatas.push(grid.AxisGuid);
          }
        }
      }
    }

    //获取基准层所有的梁
    if (
      floorModelData &&
      floorModelData["rlBeamSeg"] &&
      floorModelData["rlJoint"] &&
      floorModelData["rlGrid"]
    ) {
      const jointDatas = floorModelData["rlJoint"];
      const beamDatas = floorModelData["rlBeamSeg"];
      const gridDatas = floorModelData["rlGrid"];
      for (const key in beamDatas) {
        //获取梁的网格
        const gridGuid = beamDatas[key].GridGuid;
        const grid = gridGuid ? gridDatas[gridGuid] : null;
        if (grid) {
          //计算网格位置
          const joint_1 = jointDatas[grid.Jt1Guid];
          const joint_2 = jointDatas[grid.Jt2Guid];
          if (!joint_1 || !joint_2) {
            continue;
          }

          const position =
            Math.round(joint_1.X) +
            "," +
            Math.round(joint_1.Y) +
            "," +
            Math.round(joint_2.X) +
            "," +
            Math.round(joint_2.Y);
          //记录梁数据
          if (!totalBeamData[position])
            totalBeamData[position] = beamDatas[key];

          //记录辅轴线数据
          if (
            !mainAxisDatas.includes(grid.AxisGuid) &&
            !subAxisDatas.includes(grid.AxisGuid)
          ) {
            subAxisDatas.push(grid.AxisGuid);
          }
        }
      }
    }

    //获取基准层所有轴线
    if (
      floorModelData &&
      floorModelData["rlAxis"] &&
      floorModelData["rlJoint"]
    ) {
      const jointDatas = floorModelData["rlJoint"]; //节点数据
      const axisDatas = floorModelData["rlAxis"]; //轴线数据
      const gridDatas = floorModelData["rlGrid"]; //网格数据
      for (const axisKey in axisDatas) {
        //获取轴线线段
        const joint_1 = jointDatas[axisDatas[axisKey].Jt1Guid];
        const joint_2 = jointDatas[axisDatas[axisKey].Jt2Guid];
        if (!joint_1 || !joint_2) {
          continue;
        }

        if (axisDatas[axisKey].IsMainAxis < 0) {
          let grid = Object.values(gridDatas).filter(
            (item) => item.AxisGuid == axisKey
          );
          if (grid && grid.length) {
            let stArcPoint = null;
            let edArcPoint = null;
            let stAngle = 10000;
            let edAngle = -10000;
            // 获取网格的起点和终点--按照角度排序
            let matchGrids = grid.filter(
              (item) => item.AxisGuid == axisKey && item.Jt0Guid
            );
            if (matchGrids.length == 0) {
              continue;
            }

            let axisPoints = [];
            //通过圆弧网格的相交点，将网格连接为轴线
            for (const gridObj of matchGrids) {
              if (gridObj.Jt0Guid) {
                if (axisPoints.length == 0) {
                  axisPoints.push(gridObj.Jt1Guid);
                  axisPoints.push(gridObj.Jt2Guid);
                } else {
                  const index1 = axisPoints.indexOf(gridObj.Jt1Guid);
                  const index2 = axisPoints.indexOf(gridObj.Jt2Guid);
                  if (index1 > -1 && index2 > -1) {
                    //不必加入
                  } else if (index1 > -1) {
                    axisPoints.splice(index1 + 1, 0, gridObj.Jt2Guid);
                  } else if (index2 > -1) {
                    axisPoints.splice(index2 + 1, 0, gridObj.Jt1Guid);
                  } else {
                    axisPoints.push(gridObj.Jt1Guid);
                    axisPoints.push(gridObj.Jt2Guid);
                  }
                }
              }
            }

            stArcPoint = jointDatas[axisPoints[0]];
            edArcPoint = jointDatas[axisPoints[axisPoints.length - 1]];

            // console.log("axisPoints", axisPoints, stArcPoint, edArcPoint);

            // for (let i = 0; i < matchGrids.length; i++) {
            //   let gridObj = matchGrids[i];

            //   if (!gridObj.Jt0Guid || gridObj.AxisGuid != key) {
            //     continue;
            //   }
            //   let gridjt1 = jointDatas[gridObj.Jt1Guid];
            //   let gridjt2 = jointDatas[gridObj.Jt2Guid];

            //   // if (gridjt1 && gridjt2) {
            //   //   let itemPt1 = new THREE.Vector3(gridjt1.X, gridjt1.Y, 0);
            //   //   let itemPt2 = new THREE.Vector3(gridjt2.X, gridjt2.Y, 0);
            //   //   const startAngle2 = calculateArcAngle(itemPt1, itemPt2);
            //   //   const endAngle2 = calculateArcAngle(itemPt1, itemPt2);
            //   //   axisPoints.push({
            //   //     angle: startAngle2,
            //   //     obj: gridjt1,
            //   //     pt: itemPt1,
            //   //   });
            //   //   axisPoints.push({
            //   //     angle: endAngle2,
            //   //     obj: gridjt2,
            //   //     pt: itemPt2,
            //   //   });
            //   // }
            //   // sortArcAxisData(axisPoints, startAngle2, endAngle2);

            //   if (gridjt1 && gridjt2) {
            //     let angle1 = calculateArcAngle(
            //       new THREE.Vector3(joint_1.X, joint_1.Y, 0),
            //       new THREE.Vector3(gridjt1.X, gridjt1.Y, 0)
            //     );
            //     let angle2 = calculateArcAngle(
            //       new THREE.Vector3(joint_1.X, joint_1.Y, 0),
            //       new THREE.Vector3(gridjt2.X, gridjt2.Y, 0)
            //     );

            //     if (angle1 < angle2) {
            //       if (angle1 < stAngle) {
            //         stArcPoint = gridjt1;
            //         stAngle = angle1;
            //       }

            //       if (angle2 > edAngle) {
            //         edArcPoint = gridjt2;
            //         edAngle = angle2;
            //       }
            //     } else {
            //       if (angle2 < stAngle) {
            //         stArcPoint = gridjt2;
            //         stAngle = angle2;
            //       }

            //       if (angle1 > edAngle) {
            //         edArcPoint = gridjt1;
            //         edAngle = angle1;
            //       }
            //     }
            //   }
            // }

            // let pt2 = jointDatas[grid[0].Jt2Guid];
            let isExist = totalArcAxisData.filter(
              (item) =>
                Math.abs(item.center.x - joint_1.X) < 1 &&
                Math.abs(item.center.y - joint_1.Y) < 1 &&
                Math.abs(item.pt1.x - stArcPoint.X) < 1 &&
                Math.abs(item.pt1.y - stArcPoint.Y) < 1 &&
                Math.abs(item.pt2.x - edArcPoint.X) < 1 &&
                Math.abs(item.pt2.y - edArcPoint.Y) < 1
            );
            if (isExist.length == 0) {
              //计算轴线是否为主轴
              let axisType = -1; //-1:未知，-2:主轴，-3:辅轴
              if (mainAxisDatas.includes(axisKey)) {
                axisType = -2;
              } else {
                //判断是否在主轴线上
                for (const joint of jointOnMainAxis) {
                  const res = ptOnArc(
                    new THREE.Vector3(joint_1.X, joint_1.Y, 0),
                    new THREE.Vector3(joint_1.X, joint_1.Y, 0).distanceTo(
                      new THREE.Vector3(stArcPoint.X, stArcPoint.Y, 0)
                    ),
                    new THREE.Vector3(stArcPoint.X, stArcPoint.Y, 0),
                    new THREE.Vector3(edArcPoint.X, edArcPoint.Y, 0),
                    new THREE.Vector3(joint.x, joint.y, 0)
                  );

                  if (res > 0) {
                    axisType = -2;
                    break;
                  }
                }
              }
              if (axisType === 0 && subAxisDatas.includes(key)) {
                axisType = -3;
              }

              axisDatas[axisKey].IsMainAxis = axisType;

              totalArcAxisData.push({
                axisData: axisDatas[axisKey],
                center: { x: joint_1.X, y: joint_1.Y, z: 0 },
                pt1: { x: stArcPoint.X, y: stArcPoint.Y, z: 0 },
                pt2: { x: edArcPoint.X, y: edArcPoint.Y, z: 0 },
              });
            }
          }
          continue;
        }

        //获取直线方程
        const { A, B, C } = getLineEquation(
          joint_1.X,
          joint_1.Y,
          joint_2.X,
          joint_2.Y
        );

        const pt1 = { x: joint_1.X, y: joint_1.Y, z: 0 };
        const pt2 = { x: joint_2.X, y: joint_2.Y, z: 0 };
        let slope = Math.abs(B) < 1 ? 9999 : A / B; //斜率

        if (Math.abs(slope) < 0.01) {
          slope = 0;
        }
        slope = slope.toFixed(2);

        //计算轴线是否为主轴
        let axisType = 0; //0:未知，1:主轴，2:辅轴
        if (mainAxisDatas.includes(axisKey)) {
          axisType = 1;
        } else {
          //判断是否在主轴线上
          for (const joint of jointOnMainAxis) {
            const res = ptOnAxis(
              new THREE.Vector3(pt1.x, pt1.y, 0),
              new THREE.Vector3(pt2.x, pt2.y, 0),
              new THREE.Vector3(joint.x, joint.y, 0)
            );
            if (res > 0) {
              axisType = 1;
              break;
            }
          }
        }
        if (axisType === 0 && subAxisDatas.includes(axisKey)) {
          axisType = 2;
        }

        axisDatas[axisKey].IsMainAxis = axisType;

        let distance = 0;
        if (!totalAxisData[slope]) {
          totalAxisData[slope] = [];
        } else {
          //计算当前轴线到已有轴线中第一条轴线的距离
          const firstAxis = totalAxisData[slope][0];
          const ptSt = new THREE.Vector3(
            firstAxis.pt1.x,
            firstAxis.pt1.y,
            firstAxis.pt1.z
          );
          const ptEd = new THREE.Vector3(
            firstAxis.pt2.x,
            firstAxis.pt2.y,
            firstAxis.pt2.z
          );
          const lineOrigin = new THREE.Line3(ptSt, ptEd);

          const pt1_vec = new THREE.Vector3(pt1.x, pt1.y, pt1.z);
          let InsectPt = null;

          InsectPt = lineOrigin.closestPointToPoint(pt1_vec);
          if (InsectPt) {
            distance = pt1_vec.distanceTo(InsectPt);
            const perLine = new THREE.Line3(InsectPt, pt1_vec);
            const vecDir = new THREE.Vector3();
            perLine.delta(vecDir);
            if (Math.abs(distance) < 5) {
              distance = 0;
            } else {
              if (vecDir.x < -0.1) {
                distance = -distance;
              } else if (vecDir.y < -0.1) {
                distance = -distance;
              }
            }

            //处理精度问题
            vecDir.x = vecDir.x.toFixed(1);
            vecDir.y = vecDir.y.toFixed(1);
          }
        }

        //记录轴线数据
        totalAxisData[slope].push({
          axisData: axisDatas[axisKey],
          A: A.toFixed(2),
          B: B.toFixed(2),
          C: C.toFixed(2),
          distance: distance.toFixed(0),
          pt1: pt1,
          pt2: pt2,
        });
      }
    }
  }

  return {
    totalAxisData,
    totalArcAxisData,
    totalColumnData,
    totalWallData,
    totalBeamData,
  };
};

//绘制直线轴线数据
const drawAxisDrawingData = (uniqueAxisArrayData) => {
  //对轴线数据进行排序
  for (const key in uniqueAxisArrayData) {
    let axisArrayData = uniqueAxisArrayData[key];

    //如果轴线数据大于1，则进行延长轴线标注
    if (axisArrayData.length == 0) {
      continue;
    }
    //获取当前轴线数据中两端的点
    const ptStOrigin = new THREE.Vector3(
      axisArrayData[0].pt1.x,
      axisArrayData[0].pt1.y,
      axisArrayData[0].pt1.z
    );
    const ptEdOrigin = new THREE.Vector3(
      axisArrayData[0].pt2.x,
      axisArrayData[0].pt2.y,
      axisArrayData[0].pt2.z
    );
    const lineOrigin = new THREE.Line3(ptStOrigin, ptEdOrigin);
    const dirOrigin = new THREE.Vector3()
      .subVectors(ptStOrigin, ptEdOrigin)
      .normalize();
    dirOrigin.x = parseFloat(dirOrigin.x.toFixed(1));
    dirOrigin.y = parseFloat(dirOrigin.y.toFixed(1));

    const sortAxisData = []; //排序后的轴线数据
    for (const axis of axisArrayData) {
      const ptSt = new THREE.Vector3(axis.pt1.x, axis.pt1.y, axis.pt1.z);
      const ptEd = new THREE.Vector3(axis.pt2.x, axis.pt2.y, axis.pt2.z);

      //获取轴线起点和终点到最小点和最大点的距离
      let stInsertPt = lineOrigin.closestPointToPoint(ptSt);
      let edInsertPt = lineOrigin.closestPointToPoint(ptEd);
      //计算起点到插入点的距离
      if (stInsertPt) {
        let distance = ptStOrigin.distanceTo(stInsertPt);
        //计算方向向量
        const dir = new THREE.Vector3()
          .subVectors(ptStOrigin, stInsertPt)
          .normalize();
        dir.x = parseFloat(dir.x.toFixed(1));
        dir.y = parseFloat(dir.y.toFixed(1));
        //计算方向向量点积
        const dotProduct = dirOrigin.dot(dir);
        //如果点积大于0，则距离为负
        if (dotProduct > 0) {
          //distance = -distance;
        } else if (dotProduct < 0) {
          distance = -distance;
        }

        // 将 distance 和 itemTmp 添加到数组中
        sortAxisData.push({ distance, pt: stInsertPt });
      }
      if (edInsertPt) {
        let distance = ptStOrigin.distanceTo(edInsertPt);
        const dir = new THREE.Vector3()
          .subVectors(ptStOrigin, edInsertPt)
          .normalize();
        const dotProduct = dirOrigin.dot(dir);

        if (dotProduct > 0) {
          //distance = -distance;
        } else if (dotProduct < 0) {
          distance = -distance;
        }

        // 将 distance 和 itemTmp 添加到数组中
        sortAxisData.push({ distance, pt: edInsertPt });
      }
    }
    //按照距离排序
    sortAxisData.sort((a, b) => a.distance - b.distance);

    //获取最大和最小的点
    let minPt = sortAxisData[0].pt;
    let maxPt = sortAxisData[sortAxisData.length - 1].pt;
    let lineMinMax = new THREE.Line3(minPt, maxPt);
    let vecMinMax = new THREE.Vector3();
    lineMinMax.delta(vecMinMax);
    vecMinMax.normalize();

    //绘制轴线
    for (const axis of axisArrayData) {
      const ptSt = new THREE.Vector3(axis.pt1.x, axis.pt1.y, axis.pt1.z);
      const ptEd = new THREE.Vector3(axis.pt2.x, axis.pt2.y, axis.pt2.z);
      const lineOrigin = new THREE.Line3(ptSt, ptEd);

      let stInsertPt = lineOrigin.closestPointToPoint(minPt);
      let edInsertPt = lineOrigin.closestPointToPoint(maxPt);

      //向两端分别延伸500，获取直线方向
      let vecDir = new THREE.Vector3();
      lineOrigin.delta(vecDir);
      vecDir.normalize();

      //如果vecDir与vecMinMax相反，则取vecMinMax
      if (vecDir.dot(vecMinMax) < 0) {
        vecDir = vecMinMax;
      }

      stInsertPt = new THREE.Vector3(
        stInsertPt.x - vecDir.x * 1500,
        stInsertPt.y - vecDir.y * 1500,
        stInsertPt.z
      );
      edInsertPt = new THREE.Vector3(
        edInsertPt.x + vecDir.x * 1500,
        edInsertPt.y + vecDir.y * 1500,
        edInsertPt.z
      );

      //绘制轴线
      let AxisObj = new McDbPolyline();
      AxisObj.addVertexAt(
        new McGePoint3d(stInsertPt.x, stInsertPt.y, stInsertPt.z)
      );
      AxisObj.addVertexAt(
        new McGePoint3d(edInsertPt.x, edInsertPt.y, edInsertPt.z)
      );
      //轴线颜色设为红色
      AxisObj.trueColor = new McCmColor(255, 0, 0);
      AxisObj.setxDataString("AxisGuid", axis.axisData.Guid);
      let mcDbId = rlAppObj.mxcadObject.drawEntity(AxisObj);
      totalDrawingData.push(mcDbId);

      stInsertPt = new THREE.Vector3(
        stInsertPt.x - vecDir.x * 250,
        stInsertPt.y - vecDir.y * 250,
        stInsertPt.z
      );
      edInsertPt = new THREE.Vector3(
        edInsertPt.x + vecDir.x * 250,
        edInsertPt.y + vecDir.y * 250,
        edInsertPt.z
      );

      //两端绘制圆形
      let circleObj = new McDbCircle();
      circleObj.center = new McGePoint3d(
        stInsertPt.x,
        stInsertPt.y,
        stInsertPt.z
      );
      circleObj.radius = 250;
      circleObj.setxDataString("AxisGuid", axis.axisData.Guid);
      let mcDbIdCir1 = rlAppObj.mxcadObject.drawEntity(circleObj);
      totalDrawingData.push(mcDbIdCir1);

      let circleObj2 = new McDbCircle();
      circleObj2.center = new McGePoint3d(
        edInsertPt.x,
        edInsertPt.y,
        edInsertPt.z
      );
      circleObj2.radius = 250;
      circleObj2.setxDataString("AxisGuid", axis.axisData.Guid);
      let mcDbIdCir2 = rlAppObj.mxcadObject.drawEntity(circleObj2);
      totalDrawingData.push(mcDbIdCir2);

      //两端绘制文字
      let textObj = new McDbText();
      textObj.textString =
        axis.axisData.Name == "" ? "null" : axis.axisData.Name;
      textObj.alignmentPoint = textObj.position = new McGePoint3d(
        stInsertPt.x,
        stInsertPt.y,
        stInsertPt.z
      );
      textObj.height = 200;
      textObj.visible = true;
      textObj.horizontalMode = 1;
      textObj.verticalMode = 2;
      textObj.setxDataString("AxisGuid", axis.axisData.Guid);
      let mcDbIdTxt = rlAppObj.mxcadObject.drawEntity(textObj);
      totalDrawingData.push(mcDbIdTxt);
      axis.textMcDbId1 = mcDbIdTxt; //记录文字的mcDbId

      let textObj2 = new McDbText();
      textObj2.textString =
        axis.axisData.Name == "" ? "null" : axis.axisData.Name;
      textObj2.alignmentPoint = textObj2.position = new McGePoint3d(
        edInsertPt.x,
        edInsertPt.y,
        edInsertPt.z
      );
      textObj2.height = 200;
      textObj2.visible = true;
      textObj2.horizontalMode = 1;
      textObj2.verticalMode = 2;
      textObj2.setxDataString("AxisGuid", axis.axisData.Guid);
      let mcDbIdTxt2 = rlAppObj.mxcadObject.drawEntity(textObj2);
      totalDrawingData.push(mcDbIdTxt2);
      axis.textMcDbId2 = mcDbIdTxt2; //记录文字的mcDbId
    }
  }
  rlAppObj.rlMxDrawObject.updateDisplay();
  return uniqueAxisArrayData;
};

//绘制弧形轴线数据
const drawArcAxisDrawingData = (uniqueArcAxisArrayData) => {
  for (const item of uniqueArcAxisArrayData) {
    let arcObj = new McDbArc();
    arcObj.center = new McGePoint3d(item.center.x, item.center.y, 0);
    let pt1 = new McGePoint3d(item.pt1.x, item.pt1.y, 0);
    let pt2 = new McGePoint3d(item.pt2.x, item.pt2.y, 0);
    arcObj.radius = arcObj.center.distanceTo(pt1);
    arcObj.startAngle = calculateArcAngle(
      new THREE.Vector3(item.center.x, item.center.y, 0),
      new THREE.Vector3(item.pt1.x, item.pt1.y, 0)
    );
    arcObj.endAngle = calculateArcAngle(
      new THREE.Vector3(item.center.x, item.center.y, 0),
      new THREE.Vector3(item.pt2.x, item.pt2.y, 0)
    );

    arcObj.trueColor = new McCmColor(255, 0, 0);
    arcObj.setxDataString("AxisGuid", item.axisData.Guid);
    let mcDbId = rlAppObj.mxcadObject.drawEntity(arcObj);
    totalDrawingData.push(mcDbId);

    let vecDirSt = new THREE.Vector3().subVectors(item.center, pt1).normalize();
    let vecDirEd = new THREE.Vector3().subVectors(item.center, pt2).normalize();
    let externPt1 = new McGePoint3d(
      pt1.x - vecDirSt.x * 2000,
      pt1.y - vecDirSt.y * 2000,
      0
    );
    let externPt2 = new McGePoint3d(
      pt2.x - vecDirEd.x * 2000,
      pt2.y - vecDirEd.y * 2000,
      0
    );
    //绘制延长线
    let lineObj = new McDbPolyline();
    lineObj.addVertexAt(pt1);
    lineObj.addVertexAt(externPt1);
    lineObj.trueColor = new McCmColor(255, 0, 0);
    lineObj.setxDataString("AxisGuid", item.axisData.Guid);
    let mcDbIdLine = rlAppObj.mxcadObject.drawEntity(lineObj);
    totalDrawingData.push(mcDbIdLine);

    //绘制延长线
    let lineObj2 = new McDbPolyline();
    lineObj2.addVertexAt(pt2);
    lineObj2.addVertexAt(externPt2);
    lineObj2.trueColor = new McCmColor(255, 0, 0);
    lineObj2.setxDataString("AxisGuid", item.axisData.Guid);
    let mcDbIdLine2 = rlAppObj.mxcadObject.drawEntity(lineObj2);
    totalDrawingData.push(mcDbIdLine2);

    //绘制圆形
    let circleObj = new McDbCircle();
    circleObj.center = new McGePoint3d(
      externPt1.x - vecDirSt.x * 250,
      externPt1.y - vecDirSt.y * 250,
      0
    );
    circleObj.radius = 250;
    circleObj.setxDataString("AxisGuid", item.axisData.Guid);
    let mcDbIdCircle = rlAppObj.mxcadObject.drawEntity(circleObj);
    totalDrawingData.push(mcDbIdCircle);

    //绘制圆形
    let circleObj2 = new McDbCircle();
    circleObj2.center = new McGePoint3d(
      externPt2.x - vecDirEd.x * 250,
      externPt2.y - vecDirEd.y * 250,
      0
    );
    circleObj2.radius = 250;
    circleObj2.setxDataString("AxisGuid", item.axisData.Guid);
    let mcDbIdCircle2 = rlAppObj.mxcadObject.drawEntity(circleObj2);
    totalDrawingData.push(mcDbIdCircle2);

    //绘制文字
    let textObj = new McDbText();
    textObj.textString = item.axisData.Name == "" ? "null" : item.axisData.Name;
    textObj.alignmentPoint = textObj.position = new McGePoint3d(
      externPt1.x - vecDirSt.x * 250,
      externPt1.y - vecDirSt.y * 250,
      0
    );
    textObj.height = 200;
    textObj.visible = true;
    textObj.horizontalMode = 1;
    textObj.verticalMode = 2;
    textObj.setxDataString("AxisGuid", item.axisData.Guid);
    let mcDbIdTxt = rlAppObj.mxcadObject.drawEntity(textObj);
    totalDrawingData.push(mcDbIdTxt);
    item.textMcDbId1 = mcDbIdTxt; //记录文字的mcDbId

    //绘制文字
    let textObj2 = new McDbText();
    textObj2.textString =
      item.axisData.Name == "" ? "null" : item.axisData.Name;
    textObj2.alignmentPoint = textObj2.position = new McGePoint3d(
      externPt2.x - vecDirEd.x * 250,
      externPt2.y - vecDirEd.y * 250,
      0
    );
    textObj2.height = 200;
    textObj2.visible = true;
    textObj2.horizontalMode = 1;
    textObj2.verticalMode = 2;
    textObj2.setxDataString("AxisGuid", item.axisData.Guid);
    let mcDbIdTxt2 = rlAppObj.mxcadObject.drawEntity(textObj2);
    totalDrawingData.push(mcDbIdTxt2);
    item.textMcDbId2 = mcDbIdTxt2; //记录文字的mcDbId
  }
  return uniqueArcAxisArrayData;
};

//绘制构件数据
const drawModelDrawingData = (
  totalColumnData,
  totalWallData,
  totalBeamData
) => {
  //绘制柱子
  for (const key in totalColumnData) {
    const columnData = totalColumnData[key];

    let points = columnData.Drawing_2D
      ? columnData.Drawing_2D.split(",").map(Number)
      : null;
    if (points && points.length > 0) {
      //绘制柱子
      let ColumnObj = new McDbPolyline();
      for (let i = 0; i < points.length; i += 3) {
        ColumnObj.addVertexAt(new McGePoint3d(points[i], points[i + 1], 0));
      }
      ColumnObj.isClosed = true;
      ColumnObj.trueColor = new McCmColor(135, 135, 135);
      let mcDbId = rlAppObj.mxcadObject.drawEntity(ColumnObj);
      totalDrawingData.push(mcDbId);
    }
  }

  //绘制墙
  for (const key in totalWallData) {
    const wallData = totalWallData[key];
    //绘制墙
    let points = wallData.Drawing_2D
      ? wallData.Drawing_2D.split(",").map(Number)
      : null;
    if (points && points.length > 0) {
      //绘制柱子
      let wallObj = new McDbPolyline();
      for (let i = 0; i < points.length; i += 3) {
        wallObj.addVertexAt(new McGePoint3d(points[i], points[i + 1], 0));
      }
      wallObj.isClosed = true;
      wallObj.trueColor = new McCmColor(0, 255, 255);
      let mcDbId = rlAppObj.mxcadObject.drawEntity(wallObj);
      totalDrawingData.push(mcDbId);
    }
  }

  //绘制梁
  for (const key in totalBeamData) {
    const beamData = totalBeamData[key];
    //绘制梁
    let points = beamData.Drawing_2D
      ? beamData.Drawing_2D.split(",").map(Number)
      : null;
    if (points && points.length > 0) {
      //绘制梁
      let beamObj = new McDbPolyline();
      for (let i = 0; i < points.length; i += 3) {
        beamObj.addVertexAt(new McGePoint3d(points[i], points[i + 1], 0));
      }
      beamObj.trueColor = new McCmColor(0, 170, 170);
      let mcDbId = rlAppObj.mxcadObject.drawEntity(beamObj);
      totalDrawingData.push(mcDbId);
    }
  }
};
//清空绘制的轴线数据
export const clearNamingDrawingData = () => {
  if (totalDrawingData && totalDrawingData.length > 0) {
    for (const mcDbId of totalDrawingData) {
      mcDbId.getMcDbEntity().erase();
    }
  }

  // 清理全局变量
  totalDrawingData = [];
  allShowAxisData = {};
  allShowArcAxisData = {};
  isExistManualAxisNaming = false;
};

//轴线自动命名
export const autoAxisNaming = async () => {
  if (!allShowAxisData || Object.keys(allShowAxisData).length === 0) {
    return;
  }

  //加loading
  showFullScreenLoading("正在布置轴线..");
  let isFilter = false; //是否需要过滤一些轴线不编号
  if (Object.keys(allShowAxisData).length > 2) {
    isFilter = true;
  }
  //对合并后的基准层进行轴线命名
  for (const key in allShowAxisData) {
    const axisArrayData = allShowAxisData[key];
    if (axisArrayData.length === 0) {
      continue; //跳过没有轴线的楼层
    }

    if (isFilter && Math.abs(key) > 0.01 && Number(key) !== 9999) {
      continue; //跳过不垂直于X轴且不垂直于Y轴的轴线
    }

    let stIndex = Number(key) === 9999 ? "1" : Number(key) >= 0 ? "A" : "1"; //斜率大于0，则从A开始，否则从1开始
    let nLastNoAxisNumber = 0; // 主轴前的辅轴计数
    let lastAxisName = ""; //上一个轴线名称
    let lastNoAxisData = []; //主轴前的辅轴数据记录
    //对轴线命名
    let isFirstMainAxis = true; //是否是第一个主轴
    for (const axis of axisArrayData) {
      //如果轴线不是主轴,也不是辅轴，则不编号
      if (axis.axisData.IsMainAxis === 0) {
        axis.axisData.Name = "";
      } else if (axis.axisData.IsMainAxis === 1) {
        for (const obj of lastNoAxisData) {
          obj.axisData.Name = `${nLastNoAxisNumber}/0${stIndex}`;
          nLastNoAxisNumber--;
        }

        nLastNoAxisNumber = 0; //主轴前的辅轴计数归0
        isFirstMainAxis = false; //不是第一个主轴
        lastNoAxisData = [];
        axis.axisData.Name = stIndex;
        lastAxisName = stIndex;
        if (stIndex === "Z") {
          stIndex = "A1";
        } else if (stIndex === "Z1") {
          stIndex = "AA2";
        } else if (stIndex === "9") {
          stIndex = "10";
        } else if (stIndex === "19") {
          stIndex = "20";
        } else if (stIndex === "29") {
          stIndex = "30";
        } else if (stIndex === "39") {
          stIndex = "40";
        } else if (stIndex === "49") {
          stIndex = "50";
        } else if (stIndex.length > 1) {
          stIndex =
            stIndex.slice(0, -1) +
            String.fromCharCode(stIndex.charCodeAt(stIndex.length - 1) + 1); // 按照assic码递增
        } else {
          stIndex = String.fromCharCode(
            stIndex.charCodeAt(stIndex.length - 1) + 1
          );
        }
        //若stIndex尾数为I或者O或者i或者o,尾数的assic码加一
        if (stIndex.slice(-1).match(/[IOioZz]/)) {
          stIndex =
            stIndex.slice(0, -1) +
            String.fromCharCode(stIndex.charCodeAt(stIndex.length - 1) + 1);
        }
      } else if (axis.axisData.IsMainAxis === 2) {
        nLastNoAxisNumber += 1;
        if (isFirstMainAxis) {
          lastNoAxisData.push(axis);
          // axis.axisData.Name = `${nLastNoAxisNumber}/0${stIndex}`;
        } else {
          axis.axisData.Name = `${nLastNoAxisNumber}/${lastAxisName}`;
        }
      }

      let textMcDbId1 = axis.textMcDbId1;
      let textMcDbId2 = axis.textMcDbId2;
      if (textMcDbId1 && textMcDbId2) {
        textMcDbId1.getMcDbEntity().textString = axis.axisData.Name;
        textMcDbId2.getMcDbEntity().textString = axis.axisData.Name;
      }
    }
  }

  await autoAllFloorAxisNaming(allShowAxisData);
  await autoAllFloorArcAxisNaming(allShowArcAxisData);
  rlAppObj.rlMxDrawObject.updateDisplay();
  tryHideFullScreenLoading();
};

//对所有自然层进行轴线命名
export const autoAllFloorAxisNaming = async (baseFloorNameData) => {
  if (!baseFloorNameData || Object.keys(baseFloorNameData).length === 0) {
    return;
  }

  let saveDataBaseFloorNameData = {}; //保存基准层轴线数据
  //获取所有自然层的轴线数据
  let rlTotalFloor = await getrlFloor();
  if (rlTotalFloor) {
    for (const floor of rlTotalFloor) {
      // 获取当前楼层轴线数据
      let floorData = await getrlStdFlr(floor.StdFlrGuid);
      if (floorData && floorData["rlAxis"] && floorData["rlJoint"]) {
        let axisDatas = floorData["rlAxis"];
        let jointDatas = floorData["rlJoint"];
        for (const key in axisDatas) {
          let axis = axisDatas[key];
          if (axis.IsMainAxis < 0) continue;

          //获取轴线线段
          const joint_1 = jointDatas[axis.Jt1Guid];
          const joint_2 = jointDatas[axis.Jt2Guid];
          if (!joint_1 || !joint_2) {
            continue;
          }
          //获取直线方程
          const { A, B, C } = getLineEquation(
            joint_1.X,
            joint_1.Y,
            joint_2.X,
            joint_2.Y
          );
          let slope = Math.abs(B) < 1 ? 9999 : A / B; //斜率
          if (Math.abs(slope) < 0.01) {
            slope = 0;
          }
          slope = slope.toFixed(2);
          if (!baseFloorNameData[slope]) {
            continue;
          }

          let baseAxisData = baseFloorNameData[slope].filter(
            (item) => Number(item.distance) === 0
          );

          if (baseAxisData.length === 0) {
            continue;
          }
          let distance = calculateParallelLineDistance(
            new THREE.Vector3(baseAxisData[0].pt1.x, baseAxisData[0].pt1.y, 0),
            new THREE.Vector3(baseAxisData[0].pt2.x, baseAxisData[0].pt2.y, 0),
            new THREE.Vector3(joint_1.X, joint_1.Y, 0)
          );

          //获取基准层中与当前轴线平行的轴线
          let matchAxis = baseFloorNameData[slope].filter(
            (item) =>
              // Math.abs(item.A - A) < 0.1 &&
              // Math.abs(item.B - B) < 0.1 &&
              // Math.abs(item.C - C) < 0.1
              Math.abs(distance - item.distance) < 1
          );
          //如果匹配到轴线，则更新轴线名称
          if (matchAxis && matchAxis.length > 0) {
            axis.IsMainAxis = matchAxis[0].axisData.IsMainAxis;
            axis.Name = matchAxis[0].axisData.Name;
            //保存基准层轴线数据
            if (!saveDataBaseFloorNameData[axis.StdFlrGuid]) {
              saveDataBaseFloorNameData[axis.StdFlrGuid] = {};
              saveDataBaseFloorNameData[axis.StdFlrGuid]["rlAxis"] = [];
            }
            saveDataBaseFloorNameData[axis.StdFlrGuid]["rlAxis"].push(axis);
          }
        }
      }
    }
  }
  //更新基准层轴线数据
  Object.keys(saveDataBaseFloorNameData).forEach(async (key) => {
    let updateObjs = saveDataBaseFloorNameData[key];
    await updateBulkRlStdFlrFieldDatas(key, updateObjs);
  });
};

//对所有自然层的圆弧轴线进行命名
const autoAllFloorArcAxisNaming = async (baseFloorNameData) => {
  if (!baseFloorNameData || baseFloorNameData.length === 0) {
    return;
  }
  // debugger;
  try {
    let saveDataBaseFloorNameData = {}; //保存基准层轴线数据
    //获取所有自然层的轴线数据
    let rlTotalFloor = await getrlFloor();
    if (rlTotalFloor) {
      for (const floor of rlTotalFloor) {
        // 获取当前楼层轴线数据
        let floorData = await getrlStdFlr(floor.StdFlrGuid);
        if (floorData && floorData["rlAxis"] && floorData["rlJoint"]) {
          let axisDatas = floorData["rlAxis"];
          let jointDatas = floorData["rlJoint"];
          let gridDatas = floorData["rlGrid"];
          for (const key in axisDatas) {
            let axis = axisDatas[key];
            if (axis.IsMainAxis > -1) continue;
            //获取轴线线段
            const joint_1 = jointDatas[axis.Jt1Guid];
            const joint_2 = jointDatas[axis.Jt2Guid];
            if (!joint_1 || !joint_2) {
              continue;
            }

            let grid = Object.values(gridDatas).filter(
              (item) => item.AxisGuid == key
            );
            if (grid && grid.length) {
              let stArcPoint = null;
              let edArcPoint = null;
              let stAngle = 10000;
              let edAngle = -10000;
              let axisPoints = [];
              // 获取网格的起点和终点--按照角度排序
              for (let i = 0; i < grid.length; i++) {
                let gridObj = grid[i];
                let gridjt1 = jointDatas[gridObj.Jt1Guid];
                let gridjt2 = jointDatas[gridObj.Jt2Guid];

                if (gridjt1 && gridjt2) {
                  if (axisPoints.length == 0) {
                    axisPoints.push(gridObj.Jt1Guid);
                    axisPoints.push(gridObj.Jt2Guid);
                  } else {
                    const index1 = axisPoints.indexOf(gridObj.Jt1Guid);
                    const index2 = axisPoints.indexOf(gridObj.Jt2Guid);
                    if (index1 > -1 && index2 > -1) {
                      //不必加入
                    } else if (index1 > -1) {
                      axisPoints.splice(index1 + 1, 0, gridObj.Jt2Guid);
                    } else if (index2 > -1) {
                      axisPoints.splice(index2 + 1, 0, gridObj.Jt1Guid);
                    } else {
                      axisPoints.push(gridObj.Jt1Guid);
                      axisPoints.push(gridObj.Jt2Guid);
                    }
                  }
                  // let angle1 = toDegrees(
                  //   calculateArcAngle(
                  //     new THREE.Vector3(joint_1.X, joint_1.Y, 0),
                  //     new THREE.Vector3(gridjt1.X, gridjt1.Y, 0)
                  //   )
                  // );
                  // let angle2 = toDegrees(
                  //   calculateArcAngle(
                  //     new THREE.Vector3(joint_1.X, joint_1.Y, 0),
                  //     new THREE.Vector3(gridjt2.X, gridjt2.Y, 0)
                  //   )
                  // );

                  // if (angle1 < angle2) {
                  //   if (angle1 < stAngle) {
                  //     stArcPoint = gridjt1;
                  //     stAngle = angle1;
                  //   }

                  //   if (angle2 > edAngle) {
                  //     edArcPoint = gridjt2;
                  //     edAngle = angle2;
                  //   }
                  // } else {
                  //   if (angle2 < stAngle) {
                  //     stArcPoint = gridjt2;
                  //     stAngle = angle2;
                  //   }

                  //   if (angle1 > edAngle) {
                  //     edArcPoint = gridjt1;
                  //     edAngle = angle1;
                  //   }
                  // }
                }
              }
              if (axisPoints.length >= 2) {
                stArcPoint = jointDatas[axisPoints[0]];
                edArcPoint = jointDatas[axisPoints[axisPoints.length - 1]];
              }

              if (stArcPoint && edArcPoint) {
                let matchAxis = baseFloorNameData.filter(
                  (item) =>
                    (Math.abs(item.pt1.x - stArcPoint.X) < 1 &&
                      Math.abs(item.pt1.y - stArcPoint.Y) < 1 &&
                      Math.abs(item.pt2.x - edArcPoint.X) < 1 &&
                      Math.abs(item.pt2.y - edArcPoint.Y) < 1) ||
                    (Math.abs(item.pt2.x - stArcPoint.X) < 1 &&
                      Math.abs(item.pt2.y - stArcPoint.Y) < 1 &&
                      Math.abs(item.pt1.x - edArcPoint.X) < 1 &&
                      Math.abs(item.pt1.y - edArcPoint.Y) < 1)
                );
                if (matchAxis && matchAxis.length > 0) {
                  axis.IsMainAxis = matchAxis[0].axisData.IsMainAxis;
                  axis.Name = matchAxis[0].axisData.Name;
                  //保存基准层轴线数据
                  if (!saveDataBaseFloorNameData[axis.StdFlrGuid]) {
                    saveDataBaseFloorNameData[axis.StdFlrGuid] = {};
                    saveDataBaseFloorNameData[axis.StdFlrGuid]["rlAxis"] = [];
                  }
                  saveDataBaseFloorNameData[axis.StdFlrGuid]["rlAxis"].push(
                    axis
                  );
                }
              }
            }
          }
        }
      }
    }
    //更新基准层轴线数据
    Object.keys(saveDataBaseFloorNameData).forEach(async (key) => {
      let updateObjs = saveDataBaseFloorNameData[key];
      await updateBulkRlStdFlrFieldDatas(key, updateObjs);
    });
  } catch (error) {
    console.log("autoAllFloorArcAxisNaming error", error);
  }
};
//自动构件命名
export const autoComponentNaming = async () => {
  try {
    //获取所有自然层的构件数据
    let rlTotalFloor = await getrlFloor();
    rlTotalFloor.sort((a, b) => a.LevelB - b.LevelB);
    let currFloorNum = 1;
    if (rlTotalFloor) {
      for (const floor of rlTotalFloor) {
        let floorData = await getrlStdFlr(floor.StdFlrGuid);
        if (floorData) {
          let saveModelDatas = {};

          let columnDatas = await autoColumnNaming(floorData);
          saveModelDatas["rlColSeg"] = columnDatas;

          //墙编号
          if (store.state.cadModules.rlProject_detail.structure_type == 11) {
            //砌体
            let wallDatas = await autoWallNaming(floorData);
            saveModelDatas["rlWallSeg"] = wallDatas;
          } else {
            //混凝土
            let wallDatas = await autoWallNaming_HNT(floorData, currFloorNum);
            saveModelDatas["rlWallSeg"] = wallDatas;
          }

          let beamDatas = await autoBeamNaming(floorData);
          saveModelDatas["rlBeamSeg"] = beamDatas;

          let slabDatas = await autoSlabNaming(floorData);
          saveModelDatas["rlSlab"] = slabDatas;

          //隔墙
          let partWallDatas = await autoPartWallNaming(floorData);
          saveModelDatas["rlPartitionWallSeg"] = partWallDatas;

          await updateBulkRlStdFlrFieldDatas(floor.StdFlrGuid, saveModelDatas);
        }
        currFloorNum++;
      }
    }
  } catch (error) {
    console.log("autoComponentNaming error", error);
  }
};

const getModelNo = (axisName, isCol = false /* 是否为柱子 */) => {
  let numberAxis = store.state.platBtns.numberAxis;
  let letterAxis = store.state.platBtns.letterAxis;
  let numberAxis2 = store.state.platBtns.numberAxis2;
  let modelNo = "";
  if (isCol) {
    //axisName只取前两个
    axisName = axisName.slice(0, 2);
  }
  for (let i = 0; i < axisName.length; i++) {
    let nextIndex = i + 1;
    if (nextIndex >= axisName.length) {
      modelNo += axisName[i];
      break;
    }
    let nextName = axisName[nextIndex];
    let isNum1 = isOnlyNumbers(axisName[i]);
    let isNum2 = isOnlyNumbers(nextName);
    modelNo += axisName[i];
    if (isNum1 && isNum2) {
      modelNo += numberAxis;
    } else if ((!isNum1 && isNum2) || (isNum1 && !isNum2)) {
      modelNo += numberAxis2;
    } else if (!isNum1 && !isNum2) {
      modelNo += letterAxis;
    }
  }
  return modelNo;
};

//自动命名一层的柱子
const autoColumnNaming = async (floorData) => {
  let saveColumnDatas = [];
  if (
    !floorData ||
    !floorData["rlColSeg"] ||
    !floorData["rlJoint"] ||
    !floorData["rlAxis"]
  ) {
    return saveColumnDatas;
  }
  try {
    let columnDatas = floorData["rlColSeg"];
    let jointDatas = floorData["rlJoint"];
    let axisDatas = floorData["rlAxis"];
    let gridDatas = floorData["rlGrid"];
    for (const key in columnDatas) {
      let column = columnDatas[key];
      let jointObj = jointDatas[column.JtGuid];
      let matchAxis = getJointAxis(jointObj, jointDatas, axisDatas, gridDatas);
      //若轴线数超过2，优先取有正交轴线
      if (matchAxis && matchAxis.length > 0) {
        // if (matchAxis.length > 2) {
        //   let calMatchAxis = [];
        //   let otherMatchAxis = [];
        //   for (let ii = 0; ii < matchAxis.length; ii++) {
        //     const axisTmp = matchAxis[ii];
        //     if (axisTmp.IsMainAxis < 0) {
        //       otherMatchAxis.push(matchAxis);
        //       continue;
        //     }
        //     const axisJt1 = jointDatas[axisTmp.Jt1Guid];
        //     const axisJt2 = jointDatas[axisTmp.Jt2Guid];
        //     const jt1Point = new THREE.Vector3(axisJt1.X, axisJt1.Y, 0);
        //     const jt2Point = new THREE.Vector3(axisJt2.X, axisJt2.Y, 0);
        //     const slope =
        //       Math.abs(jt1Point.x - jt2Point.x) < Math.exp(-1)
        //         ? 9999
        //         : (jt2Point.y - jt1Point.y) / (jt2Point.x - jt1Point.x);
        //     //判断是否正交
        //     if (slope === 9999 || Math.abs(slope) < 0.001) {
        //       calMatchAxis.push(axisTmp);
        //     } else {
        //       otherMatchAxis.push(axisTmp);
        //     }
        //   }
        //   let count = calMatchAxis.length;
        //   for (let ii = 0; count < 2 && ii < otherMatchAxis.length; ii++) {
        //     calMatchAxis.push(otherMatchAxis[ii]);
        //     count++;
        //   }
        //   matchAxis = calMatchAxis;
        // }
        matchAxis = getOrthogonalAxis(matchAxis, jointDatas);

        //获取轴线命名并组合
        let axisName = matchAxis.map((item) => item.Name);
        //对轴线命名进行排序
        axisName = sortAxisNameData(axisName);
        column.ModelNo = getModelNo(axisName, true);
        // if (matchAxis.length > 2) {
        //   column.ModelNo = axisName[0] + "-" + axisName[1];
        // } else {
        //   column.ModelNo = axisName.join("-");
        // }
        if (matchAxis.find((item) => item.IsMainAxis < 0)) {
          column.ModelNo += "(H)";
        }
        saveColumnDatas.push(column);
      }
    }
    return saveColumnDatas;
  } catch (error) {
    console.log("autoColumnNaming error", error);
    return [];
  }
};

//自动命名一层的梁
const autoBeamNaming = async (floorData) => {
  let saveBeamDatas = [];
  if (
    !floorData ||
    !floorData["rlBeamSeg"] ||
    !floorData["rlGrid"] ||
    !floorData["rlAxis"] ||
    !floorData["rlJoint"]
  ) {
    return;
  }
  //获取梁截面
  let beamSectData = await getRlBeamSect();
  const beamSectMap = new Map(beamSectData.map((item) => [item.Guid, item]));

  try {
    //获取构件数据
    let beamDatas = floorData["rlBeamSeg"];
    let gridDatas = floorData["rlGrid"];
    let axisDatas = floorData["rlAxis"];
    let jointDatas = floorData["rlJoint"];
    let columnDatas = floorData["rlColSeg"];
    let wallDatas = floorData["rlWallSeg"];
    let totalLinkBeamGuids = []; //记录相邻的梁
    let subBeamDatas = {}; //记录连续合并的次梁

    //按轴线对beamDatas进行归类排序
    let namingBeamDatas = {};
    for (const key in beamDatas) {
      let beam = beamDatas[key];
      if (!beam) {
        continue;
      }

      let gridObj = gridDatas[beam.GridGuid];
      if (!gridObj) continue;
      //获取当前轴线上的网格
      let currAxisGrids = Object.values(gridDatas).filter((item) => {
        return item.AxisGuid === gridObj.AxisGuid;
      });
      currAxisGrids = currAxisGrids.map((item) => item.Guid);
      if (currAxisGrids.length === 0) {
        continue;
      }
      if (
        namingBeamDatas[currAxisGrids[0]] &&
        namingBeamDatas[currAxisGrids[0]].indexOf(beam.Guid) >= 0
      ) {
        continue;
      }
      //获取网格中存在梁
      let beamGrids = Object.values(beamDatas).filter((item) => {
        return currAxisGrids.includes(item.GridGuid);
      });
      //按照网格中点到当前网格中点的距离排序
      //对共线网格排序
      beamGrids = sortSameAxisGrids(
        axisDatas[gridObj.AxisGuid].Jt1Guid,
        axisDatas[gridObj.AxisGuid].Jt2Guid,
        jointDatas,
        gridDatas,
        beamGrids
      );
      namingBeamDatas[currAxisGrids[0]] = beamGrids;
    }

    for (const key in namingBeamDatas) {
      let beamGrids = namingBeamDatas[key];
      if (!beamGrids || beamGrids.length === 0) {
        continue;
      }
      for (const beam of beamGrids) {
        if (!beam) {
          continue;
        }
        if (totalLinkBeamGuids.indexOf(beam.Guid) >= 0) {
          continue;
        }

        let modelNoTmp = beam.ModelNo;

        let gridObj = gridDatas[beam.GridGuid];
        if (!gridObj) continue;
        let stJointGuid = gridObj.Jt1Guid;
        let edJointGuid = gridObj.Jt2Guid;
        let currSect = beamSectMap.get(beam.SectGuid);
        let currAxis = axisDatas[gridObj.AxisGuid];

        if (!currAxis) {
          continue;
        }

        let stJointMatchAxisData = []; //st端所在的轴线
        let edJointMatchAxisData = []; //ed端所在的轴线
        let stJointIsMainAxis = false; //st端是否为主轴
        let edJointIsMainAxis = false; //ed端是否为主轴
        let searchStLink = true; //是否继续查找st端相邻的梁
        let searchEdLink = true; //是否继续查找ed端相邻的梁
        let LinkBeams = []; //记录相邻的梁
        for (let i = 0; i < beamGrids.length; i++) {
          let otherBeam = beamGrids[i];
          let otherBeamGrid = gridDatas[otherBeam.GridGuid];

          //判断端部是否有墙或者梁
          if (!stJointIsMainAxis) {
            let hasColumnOrWall = isHasColumnOrWall(
              jointDatas[stJointGuid],
              columnDatas,
              gridDatas,
              wallDatas,
              gridObj.AxisGuid
            );
            let stJointMatchAxis = getJointAxis(
              jointDatas[stJointGuid],
              jointDatas,
              axisDatas,
              gridDatas
            );
            stJointMatchAxis = stJointMatchAxis.filter(
              (item) => item.Guid !== gridObj.AxisGuid
            );
            stJointMatchAxis = getOrthogonalAxis(
              stJointMatchAxis,
              jointDatas,
              axisDatas[gridObj.AxisGuid],
              true
            );
            //如果找到轴线，则判断是否为主轴
            if (stJointMatchAxis && stJointMatchAxis.length > 0) {
              stJointIsMainAxis = hasColumnOrWall;
              stJointMatchAxisData = stJointMatchAxis[0];
            }
          }
          //获取ed端所在的轴线
          if (!edJointIsMainAxis) {
            let hasColumnOrWall = isHasColumnOrWall(
              jointDatas[edJointGuid],
              columnDatas,
              gridDatas,
              wallDatas,
              gridObj.AxisGuid
            );
            let edJointMatchAxis = getJointAxis(
              jointDatas[edJointGuid],
              jointDatas,
              axisDatas,
              gridDatas
            );
            edJointMatchAxis = edJointMatchAxis.filter(
              (item) => item.Guid !== gridObj.AxisGuid
            );
            edJointMatchAxis = getOrthogonalAxis(
              edJointMatchAxis,
              jointDatas,
              axisDatas[gridObj.AxisGuid],
              true
            );
            //如果��到轴线，则判断是否为主轴
            if (edJointMatchAxis && edJointMatchAxis.length > 0) {
              edJointIsMainAxis = hasColumnOrWall;
              edJointMatchAxisData = edJointMatchAxis[0];
            }
          }

          if (
            beam.Guid === otherBeam.Guid ||
            totalLinkBeamGuids.indexOf(otherBeam.Guid) >= 0
          ) {
            continue;
          }

          //如果两端都是主轴，则直接命名
          if (stJointIsMainAxis && edJointIsMainAxis) {
            break;
          } else if (!searchStLink && !searchEdLink) {
            break;
          } else {
            //查找起端是否有相邻的梁
            if (!stJointIsMainAxis && searchStLink) {
              if (
                stJointGuid === otherBeamGrid.Jt1Guid ||
                stJointGuid === otherBeamGrid.Jt2Guid
              ) {
                //判断截面类型是否相同
                let otherSect = beamSectMap.get(otherBeam.SectGuid);
                if (!isSameBeamSect(currSect, otherSect)) {
                  searchStLink = false; //截面类型不同，不继续查找
                } else {
                  //判断起点的垂直方向是否存在不同高度的梁
                  let matchAxis = getJointAxis(
                    jointDatas[stJointGuid],
                    jointDatas,
                    axisDatas,
                    gridDatas
                  );

                  if (matchAxis && matchAxis.length > 1) {
                    let otherAxis = matchAxis.find(
                      (item) => item.Guid !== currAxis.Guid
                    );
                    //获取轴线上的网格
                    let otherAxisGrids = Object.values(gridDatas).filter(
                      (item) => otherAxis.Guid === item.AxisGuid
                    );
                    otherAxisGrids = otherAxisGrids.map((item) => item.Guid);
                    //获取轴线上的梁
                    let otherAxisBeamGrids = Object.values(beamDatas).filter(
                      (item) => otherAxisGrids.includes(item.GridGuid)
                    );
                    //过滤掉与当前梁不在同一端点的梁
                    otherAxisBeamGrids = otherAxisBeamGrids.filter(
                      (item) =>
                        gridDatas[item.GridGuid].Jt1Guid === stJointGuid ||
                        gridDatas[item.GridGuid].Jt2Guid === stJointGuid
                    );
                    if (otherAxisBeamGrids && otherAxisBeamGrids.length > 0) {
                      for (const prepBeam of otherAxisBeamGrids) {
                        let prepBeamGrid = gridDatas[prepBeam.GridGuid];
                        if (
                          prepBeamGrid.Jt1Guid === stJointGuid ||
                          prepBeamGrid.Jt2Guid === stJointGuid
                        ) {
                          //获取梁截面
                          let prepBeamSect = beamSectMap.get(prepBeam.SectGuid);
                          //判断当前梁是否矮于其他梁
                          if (isLowerBeamSect(currSect, prepBeamSect)) {
                            break; //与垂直方向的梁的截面类型不同，不继续查找
                          } else {
                            stJointGuid =
                              stJointGuid === otherBeamGrid.Jt1Guid
                                ? otherBeamGrid.Jt2Guid
                                : otherBeamGrid.Jt1Guid;
                            LinkBeams.push(otherBeam);
                            totalLinkBeamGuids.push(otherBeam.Guid);
                            break;
                          }
                        }
                      }
                    } else {
                      //垂直方向没有梁，则直接命名
                      stJointGuid =
                        stJointGuid === otherBeamGrid.Jt1Guid
                          ? otherBeamGrid.Jt2Guid
                          : otherBeamGrid.Jt1Guid;
                      LinkBeams.push(otherBeam);

                      totalLinkBeamGuids.push(otherBeam.Guid);
                    }
                  } else {
                    //垂直方向没有梁，则直接命名
                    stJointGuid =
                      stJointGuid === otherBeamGrid.Jt1Guid
                        ? otherBeamGrid.Jt2Guid
                        : otherBeamGrid.Jt1Guid;
                    LinkBeams.push(otherBeam);

                    totalLinkBeamGuids.push(otherBeam.Guid);
                  }
                }
              }
            }

            //查找末端是否有相邻的梁
            if (!edJointIsMainAxis && searchEdLink) {
              if (
                edJointGuid === otherBeamGrid.Jt1Guid ||
                edJointGuid === otherBeamGrid.Jt2Guid
              ) {
                //判断截面类型是否相同
                let otherSect = beamSectMap.get(otherBeam.SectGuid);
                if (!isSameBeamSect(currSect, otherSect)) {
                  searchEdLink = false; //截面类型不同，不继续查找
                } else {
                  //判断终点的垂直方向是否存在不同高度的梁
                  let matchAxis = getJointAxis(
                    jointDatas[edJointGuid],
                    jointDatas,
                    axisDatas,
                    gridDatas
                  );
                  if (matchAxis && matchAxis.length > 1) {
                    let otherAxis = matchAxis.find(
                      (item) => item.Guid !== currAxis.Guid
                    );

                    let otherAxisGrids = Object.values(gridDatas).filter(
                      (item) => otherAxis.Guid === item.AxisGuid
                    );
                    otherAxisGrids = otherAxisGrids.map((item) => item.Guid);
                    //获取轴线上的梁
                    let otherAxisBeamGrids = Object.values(beamDatas).filter(
                      (item) => otherAxisGrids.includes(item.GridGuid)
                    );

                    //过滤掉与当前梁不在同一端点的梁
                    otherAxisBeamGrids = otherAxisBeamGrids.filter(
                      (item) =>
                        gridDatas[item.GridGuid].Jt1Guid === edJointGuid ||
                        gridDatas[item.GridGuid].Jt2Guid === edJointGuid
                    );
                    if (otherAxisBeamGrids && otherAxisBeamGrids.length > 0) {
                      for (const prepBeam of otherAxisBeamGrids) {
                        let prepBeamGrid = gridDatas[prepBeam.GridGuid];
                        if (
                          prepBeamGrid.Jt1Guid === edJointGuid ||
                          prepBeamGrid.Jt2Guid === edJointGuid
                        ) {
                          //获取梁截面
                          let otherBeamSect = beamSectMap.get(
                            prepBeam.SectGuid
                          );
                          //判断当前梁是否矮于其他梁
                          if (isLowerBeamSect(currSect, otherBeamSect)) {
                            break; //垂直方向的梁截面类型不同，不继续查找
                          } else {
                            edJointGuid =
                              edJointGuid === otherBeamGrid.Jt1Guid
                                ? otherBeamGrid.Jt2Guid
                                : otherBeamGrid.Jt1Guid;
                            LinkBeams.push(otherBeam);
                            totalLinkBeamGuids.push(otherBeam.Guid);
                            break;
                          }
                        }
                      }
                    } else {
                      //垂直方向没有梁，与相邻的梁连接
                      edJointGuid =
                        edJointGuid === otherBeamGrid.Jt1Guid
                          ? otherBeamGrid.Jt2Guid
                          : otherBeamGrid.Jt1Guid;
                      LinkBeams.push(otherBeam);
                      totalLinkBeamGuids.push(otherBeam.Guid);
                    }
                  } else {
                    //垂直方向没有梁，与相邻的梁连接
                    edJointGuid =
                      edJointGuid === otherBeamGrid.Jt1Guid
                        ? otherBeamGrid.Jt2Guid
                        : otherBeamGrid.Jt1Guid;
                    LinkBeams.push(otherBeam);
                    totalLinkBeamGuids.push(otherBeam.Guid);
                  }
                }
              }
            }
            if (i === beamGrids.length - 1) {
              //获取st端所在的轴线
              if (!stJointIsMainAxis) {
                let hasColumnOrWall = isHasColumnOrWall(
                  jointDatas[stJointGuid],
                  columnDatas,
                  gridDatas,
                  wallDatas,
                  gridObj.AxisGuid
                );
                let stJointMatchAxis = getJointAxis(
                  jointDatas[stJointGuid],
                  jointDatas,
                  axisDatas,
                  gridDatas
                );
                stJointMatchAxis = stJointMatchAxis.filter(
                  (item) => item.Guid !== gridObj.AxisGuid
                );
                stJointMatchAxis = getOrthogonalAxis(
                  stJointMatchAxis,
                  jointDatas,
                  axisDatas[gridObj.AxisGuid],
                  true
                );
                //如果找到轴线，则判断是否为主轴
                if (stJointMatchAxis && stJointMatchAxis.length > 0) {
                  stJointIsMainAxis = hasColumnOrWall;
                  stJointMatchAxisData = stJointMatchAxis[0];
                }
              }

              //获取ed端所在的轴线
              if (!edJointIsMainAxis) {
                let hasColumnOrWall = isHasColumnOrWall(
                  jointDatas[edJointGuid],
                  columnDatas,
                  gridDatas,
                  wallDatas,
                  gridObj.AxisGuid
                );
                let edJointMatchAxis = getJointAxis(
                  jointDatas[edJointGuid],
                  jointDatas,
                  axisDatas,
                  gridDatas
                );
                edJointMatchAxis = edJointMatchAxis.filter(
                  (item) => item.Guid !== gridObj.AxisGuid
                );
                edJointMatchAxis = getOrthogonalAxis(
                  edJointMatchAxis,
                  jointDatas,
                  axisDatas[gridObj.AxisGuid],
                  true
                );
                //如果找到轴线，则判断是否为主轴
                if (edJointMatchAxis && edJointMatchAxis.length > 0) {
                  edJointIsMainAxis = hasColumnOrWall;
                  edJointMatchAxisData = edJointMatchAxis[0];
                }
              }
            }
          }
        }

        totalLinkBeamGuids.push(beam.Guid);

        if (stJointMatchAxisData && edJointMatchAxisData) {
          let axisNameDatas = [];
          axisNameDatas.push(stJointMatchAxisData.Name);
          axisNameDatas.push(edJointMatchAxisData.Name);
          axisNameDatas.push(currAxis.Name);
          axisNameDatas = sortAxisNameData(axisNameDatas);
          // let ModelNo = axisNameDatas.join("-");
          let ModelNo = getModelNo(axisNameDatas);
          if (
            stJointMatchAxisData.IsMainAxis < 0 ||
            edJointMatchAxisData.IsMainAxis < 0 ||
            currAxis.IsMainAxis < 0
          ) {
            ModelNo += "(H)";
          }

          LinkBeams.push(beam);

          let linkBeamLength = LinkBeams.length;
          //获取LinkBeams的guid集合
          let linkBeamGuids = LinkBeams.map((item) => item.Guid);
          for (const linkBeam of LinkBeams) {
            linkBeam.ModelNo = ModelNo;
            if (!stJointIsMainAxis && !edJointIsMainAxis) {
              linkBeam.Attribute = 2;
              //如果存在连续合并的次梁，需要对次梁进行重新命名
              if (linkBeamLength > 1) {
                if (!subBeamDatas[ModelNo]) {
                  subBeamDatas[ModelNo] = [];
                }
                subBeamDatas[ModelNo].push(linkBeam);
                continue;
              }
            } else {
              linkBeam.Attribute = 1;
            }
            let currEntOtherData = linkBeam.OtherData
              ? JSON.parse(linkBeam.OtherData)
              : {};

            //如果currEntOtherData还是字符串，再次序列化
            if (typeof currEntOtherData === "string") {
              currEntOtherData = JSON.parse(currEntOtherData);
            }

            if (typeof currEntOtherData === "string") {
              continue;
            }

            if (!currEntOtherData.sameModelEnts) {
              currEntOtherData.sameModelEnts = [];
            }
            currEntOtherData.sameModelEnts = linkBeamGuids;
            linkBeam.OtherData = JSON.stringify(currEntOtherData);

            saveBeamDatas.push(linkBeam);
          }
        }
      }
    }
    // console.log("subBeamDatas", subBeamDatas);

    if (Object.keys(subBeamDatas).length > 0) {
      saveBeamDatas.push(
        ...(await autoSubBeamNaming(floorData, subBeamDatas, beamSectMap))
      );
    }
    return saveBeamDatas;
  } catch (error) {
    console.log("autoBeamNaming error", error);
    return [];
  }
};

//自动命名一层的次梁
const autoSubBeamNaming = async (floorData, subBeamDatas, beamSectMap) => {
  try {
    let saveSubBeamDatas = [];
    if (
      !floorData ||
      !subBeamDatas ||
      Object.keys(subBeamDatas).length === 0 ||
      !floorData["rlGrid"] ||
      !floorData["rlAxis"] ||
      !floorData["rlJoint"]
    ) {
      return saveSubBeamDatas;
    }
    let gridDatas = floorData["rlGrid"];
    let axisDatas = floorData["rlAxis"];
    let jointDatas = floorData["rlJoint"];
    let beamDatas = floorData["rlBeamSeg"];

    for (const key in subBeamDatas) {
      let ModelNo = key;
      let currLinkedBeams = subBeamDatas[key];
      if (!currLinkedBeams || currLinkedBeams.length == 0) {
        continue;
      }
      currLinkedBeams = sortSameAxisGrids(
        axisDatas[gridDatas[currLinkedBeams[0].GridGuid].AxisGuid].Jt1Guid,
        axisDatas[gridDatas[currLinkedBeams[0].GridGuid].AxisGuid].Jt2Guid,
        jointDatas,
        gridDatas,
        currLinkedBeams
      );

      //查找当前梁是否存在垂直方向的梁，若存在，判断是否是主梁，如果是主梁，则断开，如果不是主梁，判断刚度（b*h*h*h）
      let namedLinkBeams = []; //记录已经命名的梁

      for (let i = 0; i < currLinkedBeams.length; i++) {
        let linkBeam = currLinkedBeams[i];
        if (namedLinkBeams.indexOf(linkBeam.Guid) >= 0) {
          continue;
        }

        let gridObj = gridDatas[linkBeam.GridGuid];
        let stJointGuid = gridObj.Jt1Guid;
        let edJointGuid = gridObj.Jt2Guid;
        let currSect = beamSectMap.get(linkBeam.SectGuid);
        let currAxis = axisDatas[gridObj.AxisGuid];
        let stJointMatchAxisData = []; //st端所在的轴线
        let edJointMatchAxisData = []; //ed端所在的轴线
        //st端所在的垂直方向轴线
        let stJointMatchAxis = getJointAxis(
          jointDatas[stJointGuid],
          jointDatas,
          axisDatas,
          gridDatas
        );
        stJointMatchAxis = stJointMatchAxis.filter(
          (item) => item.Guid !== gridObj.AxisGuid
        );
        if (stJointMatchAxis && stJointMatchAxis.length > 0) {
          stJointMatchAxisData = stJointMatchAxis[0];
        }

        //ed端所在的垂直方向轴线
        let edJointMatchAxis = getJointAxis(
          jointDatas[edJointGuid],
          jointDatas,
          axisDatas,
          gridDatas
        );
        edJointMatchAxis = edJointMatchAxis.filter(
          (item) => item.Guid !== gridObj.AxisGuid
        );
        if (edJointMatchAxis && edJointMatchAxis.length > 0) {
          edJointMatchAxisData = edJointMatchAxis[0];
        }

        let currLinkBeams = []; //记录能与当前梁连接的梁
        for (let j = 0; j < currLinkedBeams.length; j++) {
          if (j === i || namedLinkBeams.indexOf(currLinkedBeams[j].Guid) >= 0) {
            continue;
          }
          let otherLinkBeam = currLinkedBeams[j];
          let otherGridObj = gridDatas[otherLinkBeam.GridGuid];
          let otherStJointGuid = otherGridObj.Jt1Guid;
          let otherEdJointGuid = otherGridObj.Jt2Guid;
          let otherAxis = axisDatas[otherGridObj.AxisGuid];

          if (
            stJointGuid === otherStJointGuid ||
            stJointGuid === otherEdJointGuid
          ) {
            let currJointGuid =
              stJointGuid === otherStJointGuid
                ? otherEdJointGuid
                : otherStJointGuid;
            let currJointMatchAxisData = null; //当前连接的节点所在轴线
            let stJointMatchAxis = getJointAxis(
              jointDatas[currJointGuid],
              jointDatas,
              axisDatas,
              gridDatas
            );
            stJointMatchAxis = stJointMatchAxis.filter(
              (item) => item.Guid !== gridObj.AxisGuid
            );
            if (stJointMatchAxis && stJointMatchAxis.length > 0) {
              currJointMatchAxisData = stJointMatchAxis[0];
            } else {
              continue;
            }

            //获取垂直轴线上的梁
            let stPerpAxisGrids = Object.values(gridDatas).filter(
              (item) => currJointMatchAxisData.Guid === item.AxisGuid
            );
            stPerpAxisGrids = stPerpAxisGrids.map((item) => item.Guid);
            let stPerpAxisBeamGrids = Object.values(beamDatas).filter((item) =>
              stPerpAxisGrids.includes(item.GridGuid)
            );
            //过滤掉与当前梁不在同一端点的梁
            stPerpAxisBeamGrids = stPerpAxisBeamGrids.filter(
              (item) =>
                gridDatas[item.GridGuid].Jt1Guid === currJointGuid ||
                gridDatas[item.GridGuid].Jt2Guid === currJointGuid
            );
            if (stPerpAxisBeamGrids && stPerpAxisBeamGrids.length > 0) {
              // if (
              //   stPerpAxisBeamGrids.filter((item) => item.Attribute == 1).length
              // ) {
              //   currLinkBeams.push(otherLinkBeam);
              //   stJointMatchAxisData = currJointMatchAxisData;
              //   continue;
              // }

              for (const prepBeam of stPerpAxisBeamGrids) {
                // if (prepBeam.Attribute == 1) {
                //   break;
                // }
                let prepBeamSect = beamSectMap.get(prepBeam.SectGuid);
                //计算截面刚度
                if (isLowerSubBeamSect(currSect, prepBeamSect)) {
                  currLinkBeams.push(otherLinkBeam);
                  stJointMatchAxisData = currJointMatchAxisData;
                  break;
                } else {
                  stJointGuid =
                    stJointGuid === otherStJointGuid
                      ? otherEdJointGuid
                      : otherStJointGuid;

                  currLinkBeams.push(otherLinkBeam);
                  stJointMatchAxisData = currJointMatchAxisData;
                  break;
                }
              }
            } else {
              //垂直方向没有梁，则直接命名
              stJointGuid =
                stJointGuid === otherStJointGuid
                  ? otherEdJointGuid
                  : otherStJointGuid;
              currLinkBeams.push(otherLinkBeam);
              stJointMatchAxisData = currJointMatchAxisData;
            }
          } else if (
            edJointGuid === otherStJointGuid ||
            edJointGuid === otherEdJointGuid
          ) {
            let currJointGuid =
              edJointGuid === otherStJointGuid
                ? otherEdJointGuid
                : otherStJointGuid;
            let currJointMatchAxisData = edJointMatchAxisData; //当前连接的节点所在轴线
            let edJointMatchAxis = getJointAxis(
              jointDatas[currJointGuid],
              jointDatas,
              axisDatas,
              gridDatas
            );

            edJointMatchAxis = edJointMatchAxis.filter(
              (item) => item.Guid !== gridObj.AxisGuid
            );
            if (edJointMatchAxis && edJointMatchAxis.length > 0) {
              currJointMatchAxisData = edJointMatchAxis[0];
            } else {
              continue;
            }

            //获取垂直轴线上的梁
            let edPerpAxisGrids = Object.values(gridDatas).filter(
              (item) => currJointMatchAxisData.Guid === item.AxisGuid
            );
            edPerpAxisGrids = edPerpAxisGrids.map((item) => item.Guid);
            let edPerpAxisBeamGrids = Object.values(beamDatas).filter((item) =>
              edPerpAxisGrids.includes(item.GridGuid)
            );

            //过滤掉与当前梁不在同一端点的梁
            edPerpAxisBeamGrids = edPerpAxisBeamGrids.filter(
              (item) =>
                gridDatas[item.GridGuid].Jt1Guid === currJointGuid ||
                gridDatas[item.GridGuid].Jt2Guid === currJointGuid
            );

            if (edPerpAxisBeamGrids && edPerpAxisBeamGrids.length > 0) {
              // if (
              //   edPerpAxisBeamGrids.filter((item) => item.Attribute == 1).length
              // ) {
              //   currLinkBeams.push(otherLinkBeam);
              //   edJointMatchAxisData = currJointMatchAxisData;
              //   continue;
              // }
              for (const prepBeam of edPerpAxisBeamGrids) {
                // if (prepBeam.Attribute == 1) {
                //   break;
                // }
                let prepBeamSect = beamSectMap.get(prepBeam.SectGuid);
                //计算截面刚度
                if (isLowerSubBeamSect(currSect, prepBeamSect)) {
                  currLinkBeams.push(otherLinkBeam);
                  edJointMatchAxisData = currJointMatchAxisData;
                  break;
                } else {
                  edJointGuid =
                    edJointGuid === otherStJointGuid
                      ? otherEdJointGuid
                      : otherStJointGuid;
                  currLinkBeams.push(otherLinkBeam);
                  edJointMatchAxisData = currJointMatchAxisData;
                  break;
                }
              }
            } else {
              //垂直方向没有梁，则直接命名
              edJointGuid =
                edJointGuid === otherStJointGuid
                  ? otherEdJointGuid
                  : otherStJointGuid;
              currLinkBeams.push(otherLinkBeam);
              edJointMatchAxisData = currJointMatchAxisData;
            }
          }
        }

        currLinkBeams.push(linkBeam);

        if (stJointMatchAxisData && edJointMatchAxisData) {
          let axisNameDatas = [];
          axisNameDatas.push(stJointMatchAxisData.Name);
          axisNameDatas.push(edJointMatchAxisData.Name);
          axisNameDatas.push(currAxis.Name);
          axisNameDatas = sortAxisNameData(axisNameDatas);
          // let ModelNo = axisNameDatas.join("-");
          let ModelNo = getModelNo(axisNameDatas);
          if (
            stJointMatchAxisData.IsMainAxis < 0 ||
            edJointMatchAxisData.IsMainAxis < 0 ||
            currAxis.IsMainAxis < 0
          ) {
            ModelNo += "(H)";
          }
          //获取LinkBeams的guid集合
          let linkBeamGuids = currLinkBeams.map((item) => item.Guid);
          for (const linkBeam of currLinkBeams) {
            linkBeam.ModelNo = ModelNo;
            let currEntOtherData = linkBeam.OtherData
              ? JSON.parse(linkBeam.OtherData)
              : {};

            //如果currEntOtherData还是字符串，再次序列化
            if (typeof currEntOtherData === "string") {
              currEntOtherData = JSON.parse(currEntOtherData);
            }
            if (typeof currEntOtherData === "string") {
              continue;
            }
            if (!currEntOtherData.sameModelEnts) {
              currEntOtherData.sameModelEnts = [];
            }
            currEntOtherData.sameModelEnts = linkBeamGuids;
            linkBeam.OtherData = JSON.stringify(currEntOtherData);
            saveSubBeamDatas.push(linkBeam);
            namedLinkBeams.push(linkBeam.Guid);
          }
        }
      }
    }
    return saveSubBeamDatas;
  } catch (error) {
    console.log("autoSubBeamNaming error", error);
    return [];
  }
};

//自动命名一层的墙
const autoWallNaming = async (floorData) => {
  try {
    let saveWallDatas = [];
    if (
      !floorData ||
      !floorData["rlWallSeg"] ||
      !floorData["rlGrid"] ||
      !floorData["rlAxis"] ||
      !floorData["rlJoint"]
    ) {
      return saveWallDatas;
    }

    let wallDatas = floorData["rlWallSeg"];
    let gridDatas = floorData["rlGrid"];
    let axisDatas = floorData["rlAxis"];
    let jointDatas = floorData["rlJoint"];
    let totalLinkWallGuids = []; //记录相邻的墙

    //按轴线对wallDatas进行归类排序
    let namingWallDatas = {};
    for (const key in wallDatas) {
      let wall = wallDatas[key];
      if (!wall) {
        continue;
      }
      let gridObj = gridDatas[wall.GridGuid];
      if (!gridObj) {
        continue;
      }
      let currAxisGrids = Object.values(gridDatas).filter((item) => {
        return item.AxisGuid === gridObj.AxisGuid;
      });
      currAxisGrids = currAxisGrids.map((item) => item.Guid);
      if (currAxisGrids.length === 0) {
        continue;
      }
      if (
        namingWallDatas[currAxisGrids[0]] &&
        namingWallDatas[currAxisGrids[0]].indexOf(wall.Guid) >= 0
      ) {
        continue;
      }
      let wallGrids = Object.values(wallDatas).filter((item) => {
        return currAxisGrids.includes(item.GridGuid);
      });

      //按照网格中点到当前网格中点的距离排序
      //对共线网格排序
      console.log("wallGrids", gridObj.AxisGuid, axisDatas[gridObj.AxisGuid]);

      wallGrids = sortSameAxisGrids(
        axisDatas[gridObj.AxisGuid].Jt1Guid,
        axisDatas[gridObj.AxisGuid].Jt2Guid,
        jointDatas,
        gridDatas,
        wallGrids
      );

      namingWallDatas[currAxisGrids[0]] = wallGrids;
    }

    for (const key in namingWallDatas) {
      let wallGrids = namingWallDatas[key];
      if (!wallGrids || wallGrids.length === 0) {
        continue;
      }
      for (const wall of wallGrids) {
        if (!wall) {
          continue;
        }

        if (totalLinkWallGuids.indexOf(wall.Guid) >= 0) {
          continue;
        }

        let gridObj = gridDatas[wall.GridGuid];
        if (!gridObj) {
          continue;
        }
        let stJointGuid = gridObj.Jt1Guid;
        let edJointGuid = gridObj.Jt2Guid;

        let currAxis = axisDatas[gridObj.AxisGuid];
        if (!currAxis) {
          continue;
        }

        let stJointMatchAxisData = []; //st端所在的轴线
        let edJointMatchAxisData = []; //ed端所在的轴线
        let stJointIsMainAxis = false; //st端是否为主轴
        let edJointIsMainAxis = false; //ed端是否为主轴
        let searchStLink = true; //是否继续查找st端相邻的墙
        let searchEdLink = true; //是否继续查找ed端相邻的墙
        let LinkWalls = []; //记录相邻的墙
        for (let i = 0; i < wallGrids.length; i++) {
          let otherWall = wallGrids[i];
          let otherWallGrid = gridDatas[otherWall.GridGuid];
          //获取st端所在的轴线
          if (!stJointIsMainAxis) {
            let stJointMatchAxis = getJointAxis(
              jointDatas[stJointGuid],
              jointDatas,
              axisDatas,
              gridDatas
            );
            stJointMatchAxis = stJointMatchAxis.filter(
              (item) => item.Guid !== gridObj.AxisGuid
            );
            //如果找到轴线，则判断是否为主轴
            if (stJointMatchAxis && stJointMatchAxis.length > 0) {
              stJointIsMainAxis = stJointMatchAxis[0].IsMainAxis === 1;
              stJointMatchAxisData = stJointMatchAxis[0];
            }
          }

          //获取ed端所在的轴线
          if (!edJointIsMainAxis) {
            let edJointMatchAxis = getJointAxis(
              jointDatas[edJointGuid],
              jointDatas,
              axisDatas,
              gridDatas
            );
            edJointMatchAxis = edJointMatchAxis.filter(
              (item) => item.Guid !== gridObj.AxisGuid
            );
            //如果找到轴线，则判断是否为主轴
            if (edJointMatchAxis && edJointMatchAxis.length > 0) {
              edJointIsMainAxis =
                edJointMatchAxis[0].IsMainAxis === 1 ||
                edJointMatchAxis[0].IsMainAxis === -2;
              edJointMatchAxisData = edJointMatchAxis[0];
            }
          }
          if (
            wall.GridGuid === otherWall.GridGuid ||
            totalLinkWallGuids.indexOf(otherWall.Guid) >= 0
          ) {
            continue;
          }
          //如果两端都是主轴，则直接命名
          if (stJointIsMainAxis && edJointIsMainAxis) {
            break;
          } else if (!searchStLink && !searchEdLink) {
            break;
          } else {
            if (!stJointIsMainAxis && searchStLink) {
              if (
                stJointGuid === otherWallGrid.Jt1Guid ||
                stJointGuid === otherWallGrid.Jt2Guid
              ) {
                stJointGuid =
                  stJointGuid === otherWallGrid.Jt1Guid
                    ? otherWallGrid.Jt2Guid
                    : otherWallGrid.Jt1Guid;
                if (LinkWalls.indexOf(otherWall) < 0) {
                  LinkWalls.push(otherWall);
                  totalLinkWallGuids.push(otherWall.Guid);
                }
              } else {
                searchStLink = false;
                // continue;
              }
            }
            if (!edJointIsMainAxis && searchEdLink) {
              if (
                edJointGuid === otherWallGrid.Jt1Guid ||
                edJointGuid === otherWallGrid.Jt2Guid
              ) {
                edJointGuid =
                  edJointGuid === otherWallGrid.Jt1Guid
                    ? otherWallGrid.Jt2Guid
                    : otherWallGrid.Jt1Guid;
                if (LinkWalls.indexOf(otherWall) < 0) {
                  LinkWalls.push(otherWall);
                  totalLinkWallGuids.push(otherWall.Guid);
                }
              } else {
                searchEdLink = false;
                // continue;
              }
            }

            if (i === wallGrids.length - 1) {
              //获取st端所在的轴线
              if (!stJointIsMainAxis) {
                let stJointMatchAxis = getJointAxis(
                  jointDatas[stJointGuid],
                  jointDatas,
                  axisDatas,
                  gridDatas
                );
                stJointMatchAxis = stJointMatchAxis.filter(
                  (item) => item.Guid !== gridObj.AxisGuid
                );
                //如果找到轴线，则判断是否为主轴
                if (stJointMatchAxis && stJointMatchAxis.length > 0) {
                  stJointIsMainAxis =
                    stJointMatchAxis[0].IsMainAxis === 1 ||
                    stJointMatchAxis[0].IsMainAxis === -2;
                  stJointMatchAxisData = stJointMatchAxis[0];
                }
              }

              //获取ed端所在的轴线
              if (!edJointIsMainAxis) {
                let edJointMatchAxis = getJointAxis(
                  jointDatas[edJointGuid],
                  jointDatas,
                  axisDatas,
                  gridDatas
                );
                edJointMatchAxis = edJointMatchAxis.filter(
                  (item) => item.Guid !== gridObj.AxisGuid
                );
                //如果找到轴线，则判断是否为主轴
                if (edJointMatchAxis && edJointMatchAxis.length > 0) {
                  edJointIsMainAxis =
                    edJointMatchAxis[0].IsMainAxis === 1 ||
                    edJointMatchAxis[0].IsMainAxis === -2;
                  edJointMatchAxisData = edJointMatchAxis[0];
                }
              }
            }
          }
        }

        totalLinkWallGuids.push(wall.Guid);

        if (stJointIsMainAxis || edJointIsMainAxis) {
          let axisNameDatas = [];
          // if (stJointIsMainAxis) {
          axisNameDatas.push(stJointMatchAxisData.Name);
          // }
          // if (edJointIsMainAxis) {
          axisNameDatas.push(edJointMatchAxisData.Name);
          // }
          axisNameDatas.push(currAxis.Name);
          axisNameDatas = sortAxisNameData(axisNameDatas);
          // let ModelNo = axisNameDatas.join("-");
          let ModelNo = getModelNo(axisNameDatas);
          if (
            stJointMatchAxisData.IsMainAxis < 0 ||
            edJointMatchAxisData.IsMainAxis < 0 ||
            currAxis.IsMainAxis < 0
          ) {
            ModelNo += "(H)";
          }

          LinkWalls.push(wall);
          for (const linkWall of LinkWalls) {
            linkWall.ModelNo = ModelNo;
            saveWallDatas.push(linkWall);
          }
        }
      }
    }
    return saveWallDatas;
  } catch (error) {
    console.log("autoWallNaming error", error);
    return [];
  }
};

//墙自动编号-2025.11.28
//区分砌体和混凝土
const autoWallNaming_HNT = async (floorData, currFloorNum) => {
  try {
    let saveWallDatas = [];
    if (
      !floorData ||
      !floorData["rlWallSeg"] ||
      !floorData["rlGrid"] ||
      !floorData["rlAxis"] ||
      !floorData["rlJoint"]
    ) {
      return saveWallDatas;
    }

    let wallDatas = floorData["rlWallSeg"];
    let gridDatas = floorData["rlGrid"];
    let axisDatas = floorData["rlAxis"];
    let jointDatas = floorData["rlJoint"];
    let totalLinkWallGuids = []; //记录相邻的墙

    //获取梁截面
    let WallHoleSectData = await getRlWallHoleDef();
    const WallHoleSectMap = new Map(
      WallHoleSectData.map((item) => [item.Guid, item])
    );
    let wallcolNo = 1;
    let wallbeamNo = 1;

    //判断是否是地下室，如果是地下室，获取楼层中的外墙
    let outWallDatas = [];
    if (
      store.state.cadModules.undergroundNumber > 0 &&
      currFloorNum <= store.state.cadModules.undergroundNumber
    ) {
      outWallDatas = calUndergroundOutWall(
        wallDatas,
        gridDatas,
        axisDatas,
        jointDatas
      );
    }

    //按轴线对wallDatas进行归类排序
    let namingWallDatas = {};
    for (const key in wallDatas) {
      let wall = wallDatas[key];
      if (!wall) {
        continue;
      }
      let gridObj = gridDatas[wall.GridGuid];
      if (!gridObj) {
        continue;
      }
      let currAxisGrids = Object.values(gridDatas).filter((item) => {
        return item.AxisGuid === gridObj.AxisGuid;
      });
      currAxisGrids = currAxisGrids.map((item) => item.Guid);
      if (currAxisGrids.length === 0) {
        continue;
      }
      if (
        namingWallDatas[currAxisGrids[0]] &&
        namingWallDatas[currAxisGrids[0]].indexOf(wall.Guid) >= 0
      ) {
        continue;
      }
      let wallGrids = Object.values(wallDatas).filter((item) => {
        return currAxisGrids.includes(item.GridGuid);
      });

      //按照网格中点到当前网格中点的距离排序
      //对共线网格排序
      wallGrids = sortSameAxisGrids(
        axisDatas[gridObj.AxisGuid].Jt1Guid,
        axisDatas[gridObj.AxisGuid].Jt2Guid,
        jointDatas,
        gridDatas,
        wallGrids
      );

      namingWallDatas[currAxisGrids[0]] = wallGrids;
    }

    for (const key in namingWallDatas) {
      let wallGrids = namingWallDatas[key];
      if (!wallGrids || wallGrids.length === 0) {
        continue;
      }
      for (const wall of wallGrids) {
        if (!wall) {
          continue;
        }

        if (totalLinkWallGuids.indexOf(wall.Guid) >= 0) {
          continue;
        }

        let gridObj = gridDatas[wall.GridGuid];
        if (!gridObj) {
          continue;
        }
        let stJointGuid = gridObj.Jt1Guid;
        let edJointGuid = gridObj.Jt2Guid;

        let currAxis = axisDatas[gridObj.AxisGuid];
        if (!currAxis) {
          continue;
        }
        let joint1 = jointDatas[stJointGuid];
        let joint2 = jointDatas[edJointGuid];
        let vec = new THREE.Vector3(
          joint2.X - joint1.X,
          joint2.Y - joint1.Y,
          0
        ).normalize();

        // let stJointIsMainAxis = false; //st端是否为主轴
        // let edJointIsMainAxis = false; //ed端是否为主轴
        let searchStLink = true; //是否继续查找st端相邻的墙
        let searchEdLink = true; //是否继续查找ed端相邻的墙
        let LinkWalls = []; //记录相邻的墙
        for (let i = 0; i < wallGrids.length; i++) {
          if (!searchStLink && !searchEdLink) break; //两端都
          let otherWall = wallGrids[i];
          let otherWallGrid = gridDatas[otherWall.GridGuid];

          if (
            wall.GridGuid === otherWall.GridGuid ||
            totalLinkWallGuids.indexOf(otherWall.Guid) >= 0
          ) {
            continue;
          }

          //查看起端是否存在相邻的墙
          if (searchStLink) {
            if (
              stJointGuid === otherWallGrid.Jt1Guid ||
              stJointGuid === otherWallGrid.Jt2Guid
            ) {
              stJointGuid =
                stJointGuid === otherWallGrid.Jt1Guid
                  ? otherWallGrid.Jt2Guid
                  : otherWallGrid.Jt1Guid;
              if (LinkWalls.indexOf(otherWall) < 0) {
                LinkWalls.push(otherWall);
                totalLinkWallGuids.push(otherWall.Guid);
              }
            } else {
              searchStLink = false;
              // continue;
            }
          }

          if (searchEdLink) {
            if (
              edJointGuid === otherWallGrid.Jt1Guid ||
              edJointGuid === otherWallGrid.Jt2Guid
            ) {
              edJointGuid =
                edJointGuid === otherWallGrid.Jt1Guid
                  ? otherWallGrid.Jt2Guid
                  : otherWallGrid.Jt1Guid;
              if (LinkWalls.indexOf(otherWall) < 0) {
                LinkWalls.push(otherWall);
                totalLinkWallGuids.push(otherWall.Guid);
              }
            } else {
              searchEdLink = false;
              // continue;
            }
          }
        }

        totalLinkWallGuids.push(wall.Guid);
        //st端所在的轴线
        let stJointMatchAxisData = getJointAxis(
          jointDatas[stJointGuid],
          jointDatas,
          axisDatas,
          gridDatas
        ).filter((item) => item.Guid !== gridObj.AxisGuid && item.Name);
        //ed端所在的轴线
        let edJointMatchAxisData = getJointAxis(
          jointDatas[edJointGuid],
          jointDatas,
          axisDatas,
          gridDatas
        ).filter((item) => item.Guid !== gridObj.AxisGuid && item.Name);
        //若起端没有轴线
        if (stJointMatchAxisData.length == 0) {
          stJointMatchAxisData = getNearestJointAxis(
            jointDatas[stJointGuid],
            jointDatas,
            axisDatas,
            gridDatas,
            gridObj.AxisGuid,
            new THREE.Vector3(-vec.x, -vec.y, 0)
          );
        }
        if (edJointMatchAxisData.length == 0) {
          edJointMatchAxisData = getNearestJointAxis(
            jointDatas[edJointGuid],
            jointDatas,
            axisDatas,
            gridDatas,
            gridObj.AxisGuid,
            vec
          );
        }

        if (
          stJointMatchAxisData &&
          stJointMatchAxisData.length > 0 &&
          edJointMatchAxisData &&
          edJointMatchAxisData.length > 0
        ) {
          let axisNameDatas = [];
          // if (stJointIsMainAxis) {
          axisNameDatas.push(stJointMatchAxisData[0].Name);
          // }
          // if (edJointIsMainAxis) {
          axisNameDatas.push(edJointMatchAxisData[0].Name);
          // }
          axisNameDatas.push(currAxis.Name);
          axisNameDatas = sortAxisNameData(axisNameDatas);
          // let ModelNo = axisNameDatas.join("-");
          let ModelNo = getModelNo(axisNameDatas);
          if (
            stJointMatchAxisData[0].IsMainAxis < 0 ||
            edJointMatchAxisData[0].IsMainAxis < 0 ||
            currAxis.IsMainAxis < 0
          ) {
            ModelNo += "(H)";
          }

          LinkWalls.push(wall);

          let res = null;
          if (
            outWallDatas.length > 0 &&
            outWallDatas.filter((item) => item.Guid === wall.Guid).length > 0
          ) {
            //按外墙编号
            res = await autoOutwallNo_HNT(
              LinkWalls,
              floorData,
              wallcolNo,
              wallbeamNo,
              WallHoleSectMap
            );
          } else {
            res = await autoWallNo_HNT(
              LinkWalls,
              floorData,
              wallcolNo,
              wallbeamNo,
              WallHoleSectMap,
              gridDatas,
              axisDatas,
              jointDatas
            );
          }
          if (res) {
            wallcolNo = res.wallcolNo;
            wallbeamNo = res.wallbeamNo;

            // LinkWalls = res.wallGrids;
            for (const linkWall of res.wallGrids) {
              linkWall.ModelNo = ModelNo;
              saveWallDatas.push(linkWall);
            }
          }
        }
      }
    }
    return saveWallDatas;
  } catch (error) {
    console.log("autoWallNaming error", error);
    return [];
  }
};
//根据盈建科/PKPM计算结果的呈现规则，给混凝土墙编序号（不是构件编号）
const autoWallNo_HNT = async (
  sameModelWallDatas,
  floorData,
  wallcolNo,
  wallbeamNo,
  WallHoleSectMap,
  gridDatas,
  axisDatas,
  jointDatas
) => {
  try {
    let wallDatas = sameModelWallDatas;
    if (!wallDatas || wallDatas.length === 0) {
      return [];
    }

    //按照网格中点到当前网格中点的距离排序
    //对共线网格排序
    let wallGrids = sortSameAxisGrids(
      axisDatas[gridDatas[wallDatas[0].GridGuid].AxisGuid].Jt1Guid,
      axisDatas[gridDatas[wallDatas[0].GridGuid].AxisGuid].Jt2Guid,
      jointDatas,
      gridDatas,
      wallDatas
    );
    wallGrids.forEach((wall) => {
      wall.ModelNoLinkData = [];
    });

    let sameNoWallDatas = []; //相同序号的墙Guid集合
    for (const wall of wallGrids) {
      if (!wall) {
        continue;
      }

      //判断网格上是否有墙洞
      let wallHoles = floorData["rlWallHole"]
        ? Object.values(floorData["rlWallHole"]).filter(
            (item) => item.GridGuid === wall.GridGuid
          )
        : [];
      if (wallHoles && wallHoles.length > 0) {
        wallHoles = wallHoles[0];
        let holeSect = WallHoleSectMap.get(wallHoles.SectGuid);
        //需求：当洞口任一边的边长≤180mm或洞口面积＜0.27㎡，则忽略该洞口
        if (
          holeSect &&
          (Number(holeSect.B) > 180 ||
            Number(holeSect.H) > 180 ||
            Number(holeSect.B) * Number(holeSect.H) > 2700)
        ) {
          //居左
          if (wallHoles.Ecc === 1 || wallHoles.Ecc === -1) {
            //若居右，当前与左侧其他墙归为一组
            if (wallHoles.Ecc === -1) {
              sameNoWallDatas.push(wall);
            }

            //左侧的为一类
            if (sameNoWallDatas.length > 0) {
              let sameWallGuids = sameNoWallDatas
                .map((item) => item.Guid)
                .join(",");

              for (const tmpWall of sameNoWallDatas) {
                tmpWall.ModelNoLinkData.push({
                  No: wallcolNo,
                  guids: sameWallGuids,
                });
                tmpWall.maxWallColNo = wallcolNo;
              }
              sameNoWallDatas = [];
              wallcolNo++;
            }
            // if (
            //   Object.values(floorData["rlBeamSeg"]).filter(
            //     (item) => item.GridGuid === wall.GridGuid
            //   ) == 0
            // )
            {
              //墙顶部没有梁，墙洞口部分为梁
              wall.ModelNoLinkData.push({ No: wallbeamNo, guids: wall.Guid });
              wall.maxWallBeamNo = wallbeamNo;
              wallbeamNo++;
            }
            //若居左，当前与右侧其他墙归为一组
            if (wallHoles.Ecc === 1) {
              sameNoWallDatas.push(wall);
            }
          } else {
            //左边一组
            sameNoWallDatas.push(wall);
            if (sameNoWallDatas.length > 0) {
              let sameWallGuids = sameNoWallDatas
                .map((item) => item.Guid)
                .join(",");

              for (const tmpWall of sameNoWallDatas) {
                tmpWall.ModelNoLinkData.push({
                  No: wallcolNo,
                  guids: sameWallGuids,
                });
                tmpWall.maxWallColNo = wallcolNo;
              }
              sameNoWallDatas = [];
              wallcolNo++;
            }

            //中间一组
            wall.ModelNoLinkData.push({ No: wallbeamNo, guids: wall.Guid });
            wall.maxWallBeamNo = wallbeamNo;
            wallbeamNo++;
            //右边一组
            sameNoWallDatas.push(wall);
          }
        } else {
          sameNoWallDatas.push(wall);
        }
      } else {
        sameNoWallDatas.push(wall);
      }
    }
    if (sameNoWallDatas.length > 0) {
      let sameWallGuids = sameNoWallDatas.map((item) => item.Guid).join(",");
      for (const tmpWall of sameNoWallDatas) {
        tmpWall.ModelNoLinkData.push({ No: wallcolNo, guids: sameWallGuids });
        tmpWall.maxWallColNo = wallcolNo;
      }
      sameNoWallDatas = [];
      wallcolNo++;
    }

    wallGrids.forEach((wall) => {
      wall.ModelNoLinkData = JSON.stringify(wall.ModelNoLinkData);
    });

    return { wallGrids, wallcolNo, wallbeamNo };
  } catch (error) {
    console.log("出错了：", error);
  }
};

//计算地下室的混凝土墙编号
const calUndergroundOutWall = (wallDatas, gridDatas, axisDatas, jointDatas) => {
  try {
    if (!wallDatas || Object.values(wallDatas).length == 0) return [];

    //获取所有有墙的轴线
    let axisWithWall = {};
    let vaildAxisDatas = [];
    for (const key in axisDatas) {
      const axis = axisDatas[key];
      //圆弧的暂不处理
      if (!axis || axis.IsMainAxis < 0) continue;
      const currAxisGrids = Object.values(gridDatas).filter(
        (item) => item.AxisGuid == key
      );
      if (Object.values(gridDatas).length) {
        let currAxisWalls = [];
        currAxisGrids.forEach((gridItem) => {
          const datas = Object.values(wallDatas).filter(
            (item) => item.GridGuid == gridItem.Guid
          );
          if (datas.length) {
            currAxisWalls.push(...datas);
          }
        });
        if (currAxisWalls.length) {
          axisWithWall[key] = currAxisWalls;
          vaildAxisDatas.push(axisDatas[key]);
        }
      }
    }
    if (vaildAxisDatas.length == 0) return [];

    // 找到平行线--分组:key==斜率，value==轴线数组
    const slopeGroup = {};
    //按斜率对轴线归类并排序
    for (let i = 0; i < vaildAxisDatas.length; i++) {
      const axis = vaildAxisDatas[i];
      if (axis.IsMainAxis < 0) continue;
      const pt1 = new THREE.Vector3(
        jointDatas[axis.Jt1Guid].X,
        jointDatas[axis.Jt1Guid].Y,
        0
      );
      const pt2 = new THREE.Vector3(
        jointDatas[axis.Jt2Guid].X,
        jointDatas[axis.Jt2Guid].Y,
        0
      );
      let slope =
        Math.abs(pt1.x - pt2.x) < 0.1
          ? 9999
          : (pt1.y - pt2.y) / (pt1.x - pt2.x);
      // if (slope < 0) slope = -slope;
      if (slope == -0.0) slope = 0.0; // 将0和-0统一
      slope = slope.toFixed(2);
      if (slope == -0.0) slope = 0.0;
      if (slopeGroup[slope]) {
        slopeGroup[slope].push(axis);
      } else {
        const arrayTmp = [];
        arrayTmp.push(axis);
        slopeGroup[slope] = arrayTmp;
      }
    }

    //根据斜率的分组，对轴线进行排序
    const resAxisData = {};
    // 按照分组对轴线排序
    Object.keys(slopeGroup).forEach(async (key) => {
      const value = slopeGroup[key];
      if (value && value.length > 0) {
        // 对轴线排序
        const sortAxisData = [];
        const pt1 = new THREE.Vector3(
          jointDatas[value[0].Jt1Guid].X,
          jointDatas[value[0].Jt1Guid].Y,
          0
        );
        const pt2 = new THREE.Vector3(
          jointDatas[value[0].Jt2Guid].X,
          jointDatas[value[0].Jt2Guid].Y,
          0
        );
        // 以第一条为基准，记录其他轴线到此轴线的间距（有方向）
        const lineOrigin = new THREE.Line3(pt1, pt2);
        value.forEach(async (itemTmp) => {
          const ptTmp = new THREE.Vector3(
            jointDatas[itemTmp.Jt1Guid].X,
            jointDatas[itemTmp.Jt1Guid].Y,
            0
          );
          //new THREE.Vector3(...itemTmp.m_stJoint.m_pt);
          let InsectPt = null;

          InsectPt = lineOrigin.closestPointToPoint(ptTmp);
          if (InsectPt) {
            let distance = ptTmp.distanceTo(InsectPt);
            const perLine = new THREE.Line3(InsectPt, ptTmp);
            const vecDir = new THREE.Vector3();
            perLine.delta(vecDir);
            // 处理精度问题·
            vecDir.x = vecDir.x.toFixed(1);
            vecDir.y = vecDir.y.toFixed(1);
            if (vecDir.x < 0) {
              distance = -distance;
            } else if (vecDir.y < 0) {
              distance = -distance;
            }

            // 将 distance 和 itemTmp 添加到数组中
            sortAxisData.push({ distance, item: itemTmp });
          }
        });

        // 按照 distance 数值大小排序
        sortAxisData.sort((a, b) => a.distance - b.distance);

        // 将排序后的数据存入 resAxisData
        resAxisData[key] = sortAxisData;
      }
    });

    let outWallDatas = [];
    //判断每组斜率的起始和终止轴线上的墙是否是外墙
    Object.keys(resAxisData).forEach((key) => {
      const currAxisDatas = resAxisData[key];
      //判断是否是正交轴线
      if (Number(key) == 9999 || Math.abs(Number(key)) < 0.1) {
        //正交轴线直接取第一段和最后一段轴线作为外墙轴线

        if (currAxisDatas.length > 0) {
          //起始轴线
          const startAxis = currAxisDatas[0];
          console.log("startAxis", startAxis);

          //起始轴线上的墙
          outWallDatas.push(...axisWithWall[startAxis.item.Guid]);
        }
        if (currAxisDatas.length > 1) {
          //终止轴线
          const endAxis = currAxisDatas[currAxisDatas.length - 1];
          outWallDatas.push(...axisWithWall[endAxis.item.Guid]);
        }
      }
    });

    return outWallDatas;
  } catch (error) {
    console.log("出错了：", error);
  }
};

//按外墙方式编号
const autoOutwallNo_HNT = async (
  sameModelWallDatas,
  floorData,
  wallcolNo,
  wallbeamNo,
  WallHoleSectMap
) => {
  try {
    let wallDatas = sameModelWallDatas;
    if (!wallDatas || wallDatas.length === 0) {
      return [];
    }
    wallDatas.forEach((wall) => {
      wall.ModelNoLinkData = [];
    });

    const wallHoleData = floorData["rlWallHole"];
    for (let i = 0; i < wallDatas.length; i++) {
      const wall = wallDatas[i];
      if (!wall) {
        continue;
      }

      //判断网格上是否有墙洞
      let wallHoles = wallHoleData
        ? Object.values(wallHoleData).filter(
            (item) => item.GridGuid === wall.GridGuid
          )
        : [];
      if (wallHoles && wallHoles.length > 0) {
        wallHoles = wallHoles[0];
        let holeSect = WallHoleSectMap.get(wallHoles.SectGuid);
        //需求：当洞口任一边的边长≤180mm或洞口面积＜0.27㎡，则忽略该洞口
        if (
          holeSect &&
          (Number(holeSect.B) > 180 ||
            Number(holeSect.H) > 180 ||
            Number(holeSect.B) * Number(holeSect.H) > 2700)
        ) {
          //居左
          if (wallHoles.Ecc === 1 || wallHoles.Ecc === -1) {
            //若居右，当前与左侧其他墙归为一组
            if (wallHoles.Ecc === -1) {
              wall.ModelNoLinkData.push({ No: wallcolNo, guids: wall.Guid });
              wall.maxWallColNo = wallcolNo;
              wallcolNo++;
            }

            // if (
            //   Object.values(floorData["rlBeamSeg"]).filter(
            //     (item) => item.GridGuid === wall.GridGuid
            //   ) == 0
            // )
            {
              //墙顶部没有梁，墙洞口部分为梁
              wall.ModelNoLinkData.push({ No: wallbeamNo, guids: wall.Guid });
              wall.maxWallBeamNo = wallbeamNo;
              wallbeamNo++;
            }
            //若居左，当前与右侧其他墙归为一组
            if (wallHoles.Ecc === 1) {
              wall.ModelNoLinkData.push({ No: wallcolNo, guids: wall.Guid });
              wall.maxWallColNo = wallcolNo;
              wallcolNo++;
            }
          } else {
            //左边一组
            wall.ModelNoLinkData.push({ No: wallcolNo, guids: wall.Guid });
            wall.maxWallColNo = wallcolNo;
            wallcolNo++;

            //中间一组
            wall.ModelNoLinkData.push({ No: wallbeamNo, guids: wall.Guid });
            wall.maxWallBeamNo = wallbeamNo;
            wallbeamNo++;

            //右边一组
            wall.ModelNoLinkData.push({ No: wallcolNo, guids: wall.Guid });
            wall.maxWallColNo = wallcolNo;
            wallcolNo++;
          }
        } else {
          wall.ModelNoLinkData.push({ No: wallcolNo, guids: wall.Guid });
          wall.maxWallColNo = wallcolNo;
          wallcolNo++;
        }
      } else {
        wall.ModelNoLinkData.push({ No: wallcolNo, guids: wall.Guid });
        wall.maxWallColNo = wallcolNo;
        wallcolNo++;
      }
    }

    wallDatas.forEach((wall) => {
      wall.ModelNoLinkData = JSON.stringify(wall.ModelNoLinkData);
    });

    return { wallGrids: wallDatas, wallcolNo, wallbeamNo };
  } catch (error) {
    console.log("出错了：", error);
  }
};

const autoWallNaming_QT = async (floorData) => {
  try {
    let saveWallDatas = [];
    if (
      !floorData ||
      !floorData["rlWallSeg"] ||
      !floorData["rlGrid"] ||
      !floorData["rlAxis"] ||
      !floorData["rlJoint"]
    ) {
      return saveWallDatas;
    }

    let wallDatas = floorData["rlWallSeg"];
    let gridDatas = floorData["rlGrid"];
    let axisDatas = floorData["rlAxis"];
    let jointDatas = floorData["rlJoint"];
    let totalLinkWallGuids = []; //记录相邻的墙

    //按轴线对wallDatas进行归类排序
    let namingWallDatas = {};
    for (const key in wallDatas) {
      let wall = wallDatas[key];
      if (!wall) {
        continue;
      }
      let gridObj = gridDatas[wall.GridGuid];
      if (!gridObj) {
        continue;
      }
      let currAxisGrids = Object.values(gridDatas).filter((item) => {
        return item.AxisGuid === gridObj.AxisGuid;
      });
      currAxisGrids = currAxisGrids.map((item) => item.Guid);
      if (currAxisGrids.length === 0) {
        continue;
      }
      if (
        namingWallDatas[currAxisGrids[0]] &&
        namingWallDatas[currAxisGrids[0]].indexOf(wall.Guid) >= 0
      ) {
        continue;
      }
      let wallGrids = Object.values(wallDatas).filter((item) => {
        return currAxisGrids.includes(item.GridGuid);
      });

      //按照网格中点到当前网格中点的距离排序
      //对共线网格排序
      wallGrids = sortSameAxisGrids(
        axisDatas[gridObj.AxisGuid].Jt1Guid,
        axisDatas[gridObj.AxisGuid].Jt2Guid,
        jointDatas,
        gridDatas,
        wallGrids
      );

      namingWallDatas[currAxisGrids[0]] = wallGrids;
    }

    for (const key in namingWallDatas) {
      let wallGrids = namingWallDatas[key];
      if (!wallGrids || wallGrids.length === 0) {
        continue;
      }
      for (const wall of wallGrids) {
        if (!wall) {
          continue;
        }

        if (totalLinkWallGuids.indexOf(wall.Guid) >= 0) {
          continue;
        }

        let gridObj = gridDatas[wall.GridGuid];
        if (!gridObj) {
          continue;
        }
        let stJointGuid = gridObj.Jt1Guid;
        let edJointGuid = gridObj.Jt2Guid;

        let currAxis = axisDatas[gridObj.AxisGuid];
        if (!currAxis) {
          continue;
        }
        let joint1 = jointDatas[stJointGuid];
        let joint2 = jointDatas[edJointGuid];
        let vec = new THREE.Vector3(
          joint2.X - joint1.X,
          joint2.Y - joint1.Y,
          0
        ).normalize();

        // let stJointIsMainAxis = false; //st端是否为主轴
        // let edJointIsMainAxis = false; //ed端是否为主轴
        let searchStLink = true; //是否继续查找st端相邻的墙
        let searchEdLink = true; //是否继续查找ed端相邻的墙
        let LinkWalls = []; //记录相邻的墙
        for (let i = 0; i < wallGrids.length; i++) {
          if (!searchStLink && !searchEdLink) break; //两端都
          let otherWall = wallGrids[i];
          let otherWallGrid = gridDatas[otherWall.GridGuid];

          if (
            wall.GridGuid === otherWall.GridGuid ||
            totalLinkWallGuids.indexOf(otherWall.Guid) >= 0
          ) {
            continue;
          }

          //查看起端是否存在相邻的墙
          if (searchStLink) {
            //查找垂直方向是否有墙
            let prepGrid = Object.values(gridDatas).filter(
              (item) =>
                (item.Jt1Guid === stJointGuid ||
                  item.Jt2Guid === stJointGuid) &&
                item.AxisGuid !== gridObj.AxisGuid
            );
            //如果存在垂直方向的墙，则不查找st端相邻的墙
            if (prepGrid && prepGrid.length > 0) {
              searchStLink = false;
            } else {
              if (
                stJointGuid === otherWallGrid.Jt1Guid ||
                stJointGuid === otherWallGrid.Jt2Guid
              ) {
                stJointGuid =
                  stJointGuid === otherWallGrid.Jt1Guid
                    ? otherWallGrid.Jt2Guid
                    : otherWallGrid.Jt1Guid;
                if (LinkWalls.indexOf(otherWall) < 0) {
                  LinkWalls.push(otherWall);
                  totalLinkWallGuids.push(otherWall.Guid);
                }
              } else {
                searchStLink = false;
                // continue;
              }
            }
          }

          if (searchEdLink) {
            //查找垂直方向是否有墙
            let prepGrid = Object.values(gridDatas).filter(
              (item) =>
                (item.Jt1Guid === edJointGuid ||
                  item.Jt2Guid === edJointGuid) &&
                item.AxisGuid !== gridObj.AxisGuid
            );
            //如果存在垂直方向的墙，则不查找ed端相邻的墙
            if (prepGrid && prepGrid.length > 0) {
              searchEdLink = false;
            } else {
              if (
                edJointGuid === otherWallGrid.Jt1Guid ||
                edJointGuid === otherWallGrid.Jt2Guid
              ) {
                edJointGuid =
                  edJointGuid === otherWallGrid.Jt1Guid
                    ? otherWallGrid.Jt2Guid
                    : otherWallGrid.Jt1Guid;
                if (LinkWalls.indexOf(otherWall) < 0) {
                  LinkWalls.push(otherWall);
                  totalLinkWallGuids.push(otherWall.Guid);
                }
              } else {
                searchEdLink = false;
                // continue;
              }
            }
          }
        }
        totalLinkWallGuids.push(wall.Guid);
        //st端所在的轴线
        let stJointMatchAxisData = getJointAxis(
          jointDatas[stJointGuid],
          jointDatas,
          axisDatas,
          gridDatas
        ).filter((item) => item.Guid !== gridObj.AxisGuid && item.Name);
        //ed端所在的轴线
        let edJointMatchAxisData = getJointAxis(
          jointDatas[edJointGuid],
          jointDatas,
          axisDatas,
          gridDatas
        ).filter((item) => item.Guid !== gridObj.AxisGuid && item.Name);
        //若起端没有轴线
        if (!stJointMatchAxisData || stJointMatchAxisData.length == 0) {
          stJointMatchAxisData = getNearestJointAxis(
            jointDatas[stJointGuid],
            jointDatas,
            axisDatas,
            gridDatas,
            gridObj.AxisGuid,
            new THREE.Vector3(-vec.x, -vec.y, 0)
          );
        }
        if (!edJointMatchAxisData || edJointMatchAxisData.length == 0) {
          edJointMatchAxisData = getNearestJointAxis(
            jointDatas[edJointGuid],
            jointDatas,
            axisDatas,
            gridDatas,
            gridObj.AxisGuid,
            vec
          );
        }

        if (
          stJointMatchAxisData &&
          stJointMatchAxisData.length > 0 &&
          edJointMatchAxisData &&
          edJointMatchAxisData.length > 0
        ) {
          let axisNameDatas = [];
          // if (stJointIsMainAxis) {
          axisNameDatas.push(stJointMatchAxisData[0].Name);
          // }
          // if (edJointIsMainAxis) {
          axisNameDatas.push(edJointMatchAxisData[0].Name);
          // }
          axisNameDatas.push(currAxis.Name);
          axisNameDatas = sortAxisNameData(axisNameDatas);
          // let ModelNo = axisNameDatas.join("-");
          let ModelNo = getModelNo(axisNameDatas);
          if (
            stJointMatchAxisData[0].IsMainAxis < 0 ||
            edJointMatchAxisData[0].IsMainAxis < 0 ||
            currAxis.IsMainAxis < 0
          ) {
            ModelNo += "(H)";
          }

          LinkWalls.push(wall);
          for (const linkWall of LinkWalls) {
            linkWall.ModelNo = ModelNo;
            saveWallDatas.push(linkWall);
          }
        }
      }
    }
    return saveWallDatas;
  } catch (error) {
    console.log("autoWallNaming error", error);
    return [];
  }
};

//自动命名一层的隔墙
const autoPartWallNaming = async (floorData) => {
  console.log("autoPartWallNaming");
  try {
    let saveWallDatas = [];
    if (
      !floorData ||
      !floorData["rlPartitionWallSeg"] ||
      !floorData["rlGrid"] ||
      !floorData["rlAxis"] ||
      !floorData["rlJoint"]
    ) {
      return saveWallDatas;
    }

    let partWallDatas = floorData["rlPartitionWallSeg"];
    let gridDatas = floorData["rlGrid"];
    let axisDatas = floorData["rlAxis"];
    let jointDatas = floorData["rlJoint"];
    for (const key in partWallDatas) {
      let partWall = partWallDatas[key];
      if (!partWall) {
        continue;
      }
      //依次对每一个隔墙进行命名

      let gridObj = gridDatas[partWall.GridGuid];
      if (!gridObj) {
        continue;
      }

      //获取隔墙所在的轴线
      let currAxis = axisDatas[gridObj.AxisGuid];
      if (!currAxis) {
        continue;
      }

      //获取网格起端/终端所在的轴线
      let stJointGuid = gridObj.Jt1Guid;
      let edJointGuid = gridObj.Jt2Guid;

      //获取网格起端/终端所在的轴线
      let stJointMatchAxis = getJointAxis(
        jointDatas[stJointGuid],
        jointDatas,
        axisDatas,
        gridDatas
      );
      stJointMatchAxis = stJointMatchAxis.filter(
        (item) => item.Guid !== gridObj.AxisGuid
      );

      //获取网格终端所在的轴线
      let edJointMatchAxis = getJointAxis(
        jointDatas[edJointGuid],
        jointDatas,
        axisDatas,
        gridDatas
      );
      edJointMatchAxis = edJointMatchAxis.filter(
        (item) => item.Guid !== gridObj.AxisGuid
      );

      let axisNameDatas = [];
      if (stJointMatchAxis && stJointMatchAxis.length > 0) {
        axisNameDatas.push(stJointMatchAxis[0].Name);
      }
      if (edJointMatchAxis && edJointMatchAxis.length > 0) {
        axisNameDatas.push(edJointMatchAxis[0].Name);
      }
      axisNameDatas.push(currAxis.Name);
      axisNameDatas = sortAxisNameData(axisNameDatas);
      let ModelNo = getModelNo(axisNameDatas);

      partWall.ModelNo = ModelNo;
      saveWallDatas.push(partWall);
    }
    console.log("autoPartWallNaming saveWallDatas", saveWallDatas);
    return saveWallDatas;

    // let totalLinkWallGuids = []; //记录相邻的墙

    // //按轴线对wallDatas进行归类排序
    // let namingWallDatas = {};
    // for (const key in partWallDatas) {
    //   let partWall = partWallDatas[key];
    //   if (!partWall) {
    //     continue;
    //   }
    //   let gridObj = gridDatas[partWall.GridGuid];
    //   if (!gridObj) {
    //     continue;
    //   }
    //   let currAxisGrids = Object.values(gridDatas).filter((item) => {
    //     return item.AxisGuid === gridObj.AxisGuid;
    //   });
    //   currAxisGrids = currAxisGrids.map((item) => item.Guid);
    //   if (currAxisGrids.length === 0) {
    //     continue;
    //   }
    //   if (
    //     namingWallDatas[currAxisGrids[0]] &&
    //     namingWallDatas[currAxisGrids[0]].indexOf(partWall.Guid) >= 0
    //   ) {
    //     continue;
    //   }
    //   let partWallGrids = Object.values(partWallDatas).filter((item) => {
    //     return currAxisGrids.includes(item.GridGuid);
    //   });

    //   //按照网格中点到当前网格中点的距离排序
    //   //对共线网格排序
    //   partWallGrids = sortSameAxisGrids(
    //     axisDatas[gridObj.AxisGuid].Jt1Guid,
    //     axisDatas[gridObj.AxisGuid].Jt2Guid,
    //     jointDatas,
    //     gridDatas,
    //     partWallGrids
    //   );

    //   namingWallDatas[currAxisGrids[0]] = partWallGrids;
    // }

    // for (const key in namingWallDatas) {
    //   let partWallGrids = namingWallDatas[key];
    //   if (!partWallGrids || partWallGrids.length === 0) {
    //     continue;
    //   }
    //   for (const partWall of partWallGrids) {
    //     if (!partWall) {
    //       continue;
    //     }

    //     if (totalLinkWallGuids.indexOf(partWall.Guid) >= 0) {
    //       continue;
    //     }

    //     let gridObj = gridDatas[partWall.GridGuid];
    //     if (!gridObj) {
    //       continue;
    //     }
    //     let stJointGuid = gridObj.Jt1Guid;
    //     let edJointGuid = gridObj.Jt2Guid;

    //     let currAxis = axisDatas[gridObj.AxisGuid];
    //     if (!currAxis) {
    //       continue;
    //     }

    //     let stJointMatchAxisData = []; //st端所在的轴线
    //     let edJointMatchAxisData = []; //ed端所在的轴线
    //     let stJointIsMainAxis = false; //st端是否为主轴
    //     let edJointIsMainAxis = false; //ed端是否为主轴
    //     let searchStLink = true; //是否继续查找st端相邻的墙
    //     let searchEdLink = true; //是否继续查找ed端相邻的墙
    //     let LinkWalls = []; //记录相邻的墙
    //     for (let i = 0; i < partWallGrids.length; i++) {
    //       let otherPartWall = partWallGrids[i];
    //       let otherPartWallGrid = gridDatas[otherPartWall.GridGuid];
    //       //获取st端所在的轴线
    //       if (!stJointIsMainAxis) {
    //         let stJointMatchAxis = getJointAxis(
    //           jointDatas[stJointGuid],
    //           jointDatas,
    //           axisDatas,
    //           gridDatas
    //         );
    //         stJointMatchAxis = stJointMatchAxis.filter(
    //           (item) => item.Guid !== gridObj.AxisGuid
    //         );
    //         //如果找到轴线，则判断是否为主轴
    //         if (stJointMatchAxis && stJointMatchAxis.length > 0) {
    //           stJointIsMainAxis = stJointMatchAxis[0].IsMainAxis === 1;
    //           stJointMatchAxisData = stJointMatchAxis[0];
    //         }
    //       }

    //       //获取ed端所在的轴线
    //       if (!edJointIsMainAxis) {
    //         let edJointMatchAxis = getJointAxis(
    //           jointDatas[edJointGuid],
    //           jointDatas,
    //           axisDatas,
    //           gridDatas
    //         );
    //         edJointMatchAxis = edJointMatchAxis.filter(
    //           (item) => item.Guid !== gridObj.AxisGuid
    //         );
    //         //如果找到轴线，则判断是否为主轴
    //         if (edJointMatchAxis && edJointMatchAxis.length > 0) {
    //           edJointIsMainAxis =
    //             edJointMatchAxis[0].IsMainAxis === 1 ||
    //             edJointMatchAxis[0].IsMainAxis === -2;
    //           edJointMatchAxisData = edJointMatchAxis[0];
    //         }
    //       }
    //       if (
    //         partWall.GridGuid === otherPartWall.GridGuid ||
    //         totalLinkWallGuids.indexOf(otherPartWall.Guid) >= 0
    //       ) {
    //         continue;
    //       }
    //       //如果两端都是主轴，则直接命名
    //       if (stJointIsMainAxis && edJointIsMainAxis) {
    //         break;
    //       } else if (!searchStLink && !searchEdLink) {
    //         break;
    //       } else {
    //         if (!stJointIsMainAxis && searchStLink) {
    //           if (
    //             stJointGuid === otherPartWallGrid.Jt1Guid ||
    //             stJointGuid === otherPartWallGrid.Jt2Guid
    //           ) {
    //             stJointGuid =
    //               stJointGuid === otherWallGrid.Jt1Guid
    //                 ? otherPartWallGrid.Jt2Guid
    //                 : otherPartWallGrid.Jt1Guid;
    //             if (LinkWalls.indexOf(otherPartWall) < 0) {
    //               LinkWalls.push(otherPartWall);
    //               totalLinkWallGuids.push(otherPartWall.Guid);
    //             }
    //           } else {
    //             searchStLink = false;
    //             // continue;
    //           }
    //         }
    //         if (!edJointIsMainAxis && searchEdLink) {
    //           if (
    //             edJointGuid === otherPartWallGrid.Jt1Guid ||
    //             edJointGuid === otherPartWallGrid.Jt2Guid
    //           ) {
    //             edJointGuid =
    //               edJointGuid === otherPartWallGrid.Jt1Guid
    //                 ? otherPartWallGrid.Jt2Guid
    //                 : otherPartWallGrid.Jt1Guid;
    //             if (LinkWalls.indexOf(otherPartWall) < 0) {
    //               LinkWalls.push(otherPartWall);
    //               totalLinkWallGuids.push(otherPartWall.Guid);
    //             }
    //           } else {
    //             searchEdLink = false;
    //             // continue;
    //           }
    //         }

    //         if (i === wallGrids.length - 1) {
    //           //获取st端所在的轴线
    //           if (!stJointIsMainAxis) {
    //             let stJointMatchAxis = getJointAxis(
    //               jointDatas[stJointGuid],
    //               jointDatas,
    //               axisDatas,
    //               gridDatas
    //             );
    //             stJointMatchAxis = stJointMatchAxis.filter(
    //               (item) => item.Guid !== gridObj.AxisGuid
    //             );
    //             //如果找到轴线，则判断是否为主轴
    //             if (stJointMatchAxis && stJointMatchAxis.length > 0) {
    //               stJointIsMainAxis =
    //                 stJointMatchAxis[0].IsMainAxis === 1 ||
    //                 stJointMatchAxis[0].IsMainAxis === -2;
    //               stJointMatchAxisData = stJointMatchAxis[0];
    //             }
    //           }

    //           //获取ed端所在的轴线
    //           if (!edJointIsMainAxis) {
    //             let edJointMatchAxis = getJointAxis(
    //               jointDatas[edJointGuid],
    //               jointDatas,
    //               axisDatas,
    //               gridDatas
    //             );
    //             edJointMatchAxis = edJointMatchAxis.filter(
    //               (item) => item.Guid !== gridObj.AxisGuid
    //             );
    //             //如果找到轴线，则判断是否为主轴
    //             if (edJointMatchAxis && edJointMatchAxis.length > 0) {
    //               edJointIsMainAxis =
    //                 edJointMatchAxis[0].IsMainAxis === 1 ||
    //                 edJointMatchAxis[0].IsMainAxis === -2;
    //               edJointMatchAxisData = edJointMatchAxis[0];
    //             }
    //           }
    //         }
    //       }
    //     }

    //     totalLinkWallGuids.push(partWall.Guid);

    //     if (stJointIsMainAxis || edJointIsMainAxis) {
    //       let axisNameDatas = [];
    //       // if (stJointIsMainAxis) {
    //       axisNameDatas.push(stJointMatchAxisData.Name);
    //       // }
    //       // if (edJointIsMainAxis) {
    //       axisNameDatas.push(edJointMatchAxisData.Name);
    //       // }
    //       axisNameDatas.push(currAxis.Name);
    //       axisNameDatas = sortAxisNameData(axisNameDatas);
    //       // let ModelNo = axisNameDatas.join("-");
    //       let ModelNo = getModelNo(axisNameDatas);
    //       if (
    //         stJointMatchAxisData.IsMainAxis < 0 ||
    //         edJointMatchAxisData.IsMainAxis < 0 ||
    //         currAxis.IsMainAxis < 0
    //       ) {
    //         ModelNo += "(H)";
    //       }

    //       LinkWalls.push(partWall);
    //       for (const linkPartWall of LinkWalls) {
    //         linkPartWall.ModelNo = ModelNo;
    //         saveWallDatas.push(linkPartWall);
    //       }
    //     }
    //   }
    // }
    // return saveWallDatas;
  } catch (error) {
    console.log("autoWallNaming error", error);
    return [];
  }
};

//自动命名一层的楼板
const autoSlabNaming = async (floorData) => {
  try {
    let saveSlabDatas = [];
    if (
      !floorData ||
      !floorData["rlSlab"] ||
      !floorData["rlGrid"] ||
      !floorData["rlAxis"] ||
      !floorData["rlJoint"]
    ) {
      return saveSlabDatas;
    }

    let slabDatas = floorData["rlSlab"];
    let gridDatas = floorData["rlGrid"];
    let axisDatas = floorData["rlAxis"];
    let jointDatas = floorData["rlJoint"];

    for (const key in slabDatas) {
      let slab = slabDatas[key];
      let GridsGuid = slab.GridsGuid;
      let GridsGuidArr = GridsGuid.split(",");

      let slabAxisDatas = {}; //记录楼板所在的轴线
      let withArcAxis = false; //是否存在圆弧轴线
      let arcAxisJointMatchAxisDatas = []; //弧形轴线端点所在的所有轴线
      for (const gridGuid of GridsGuidArr) {
        if (!gridGuid || !gridDatas[gridGuid]) {
          continue;
        }

        let gridObj = gridDatas[gridGuid];

        let currAxis = axisDatas[gridObj.AxisGuid];
        if (!currAxis) {
          continue;
        }
        if (currAxis.IsMainAxis < 0) {
          withArcAxis = currAxis;
        }
        let name = currAxis.Name == "" || !currAxis.Name ? "?" : currAxis.Name;
        //计算轴线的方向向量
        let currAxisPt1 = new THREE.Vector3(
          jointDatas[currAxis.Jt1Guid].X,
          jointDatas[currAxis.Jt1Guid].Y,
          0
        );
        let currAxisPt2 = new THREE.Vector3(
          jointDatas[currAxis.Jt2Guid].X,
          jointDatas[currAxis.Jt2Guid].Y,
          0
        );
        const lineOrigin = new THREE.Line3(currAxisPt1, currAxisPt2);
        const vecDir = new THREE.Vector3();
        lineOrigin.delta(vecDir);
        vecDir.normalize();
        //若vecDir方向指向左下，则取反
        if (vecDir.x < 0 || vecDir.y < 0) {
          vecDir.multiplyScalar(-1);
        }

        if (!slabAxisDatas[vecDir.x.toFixed(0) + "," + vecDir.y.toFixed(0)]) {
          slabAxisDatas[vecDir.x.toFixed(0) + "," + vecDir.y.toFixed(0)] = [];
        }

        if (
          slabAxisDatas[
            vecDir.x.toFixed(0) + "," + vecDir.y.toFixed(0)
          ].indexOf(name) < 0
        ) {
          slabAxisDatas[vecDir.x.toFixed(0) + "," + vecDir.y.toFixed(0)].push(
            name
          );
        }

        let stJoint = jointDatas[gridObj.Jt1Guid];
        let edJoint = jointDatas[gridObj.Jt2Guid];
        let stMatchAxis = getJointAxis(
          stJoint,
          jointDatas,
          axisDatas,
          gridDatas
        );
        if (stMatchAxis && stMatchAxis.length > 0) {
          if (currAxis.IsMainAxis < 0) {
            arcAxisJointMatchAxisDatas.push(...stMatchAxis);
          }
          stMatchAxis = stMatchAxis[0];

          // //计算轴线的方向向量
          // let stAxisPt1 = new THREE.Vector3(
          //   jointDatas[stMatchAxis.Jt1Guid].X,
          //   jointDatas[stMatchAxis.Jt1Guid].Y,
          //   0
          // );
          // let stAxisPt2 = new THREE.Vector3(
          //   jointDatas[stMatchAxis.Jt2Guid].X,
          //   jointDatas[stMatchAxis.Jt2Guid].Y,
          //   0
          // );
          // const lineOriginSt = new THREE.Line3(stAxisPt1, stAxisPt2);
          // const vecDirSt = new THREE.Vector3();
          // lineOriginSt.delta(vecDirSt);
          // vecDirSt.normalize();
          // //若vecDirSt方向指向左下，则取反
          // if (vecDirSt.x < 0 || vecDirSt.y < 0) {
          //   vecDirSt.multiplyScalar(-1);
          // }

          // if (
          //   !slabAxisDatas[vecDirSt.x.toFixed(0) + "," + vecDirSt.y.toFixed(0)]
          // ) {
          //   slabAxisDatas[vecDirSt.x.toFixed(0) + "," + vecDirSt.y.toFixed(0)] =
          //     [];
          // }

          // if (
          //   slabAxisDatas[
          //     vecDirSt.x.toFixed(0) + "," + vecDirSt.y.toFixed(0)
          //   ].indexOf(stMatchAxis.Name) < 0
          // ) {
          //   slabAxisDatas[
          //     vecDirSt.x.toFixed(0) + "," + vecDirSt.y.toFixed(0)
          //   ].push(stMatchAxis.Name);
          // }
        }
        let edMatchAxis = getJointAxis(
          edJoint,
          jointDatas,
          axisDatas,
          gridDatas
        );
        if (edMatchAxis && edMatchAxis.length > 0) {
          if (currAxis.IsMainAxis < 0) {
            arcAxisJointMatchAxisDatas.push(...edMatchAxis);
          }
          edMatchAxis = edMatchAxis[0];
          // //计算轴线的方向向量
          // let edAxisPt1 = new THREE.Vector3(
          //   jointDatas[edMatchAxis.Jt1Guid].X,
          //   jointDatas[edMatchAxis.Jt1Guid].Y,
          //   0
          // );
          // let edAxisPt2 = new THREE.Vector3(
          //   jointDatas[edMatchAxis.Jt2Guid].X,
          //   jointDatas[edMatchAxis.Jt2Guid].Y,
          //   0
          // );
          // const lineOriginEd = new THREE.Line3(edAxisPt1, edAxisPt2);
          // const vecDirEd = new THREE.Vector3();
          // lineOriginEd.delta(vecDirEd);
          // vecDirEd.normalize();
          // //若vecDirEd方向指向左下，则取反
          // if (vecDirEd.x < 0 || vecDirEd.y < 0) {
          //   vecDirEd.multiplyScalar(-1);
          // }

          // if (
          //   !slabAxisDatas[vecDirEd.x.toFixed(0) + "," + vecDirEd.y.toFixed(0)]
          // ) {
          //   slabAxisDatas[vecDirEd.x.toFixed(0) + "," + vecDirEd.y.toFixed(0)] =
          //     [];
          // }

          // if (
          //   slabAxisDatas[
          //     vecDirEd.x.toFixed(0) + "," + vecDirEd.y.toFixed(0)
          //   ].indexOf(edMatchAxis.Name) < 0
          // ) {
          //   slabAxisDatas[
          //     vecDirEd.x.toFixed(0) + "," + vecDirEd.y.toFixed(0)
          //   ].push(edMatchAxis.Name);
          // }
        }
      }

      let ModelNo = "";
      let slabAxisNames = [];

      Object.keys(slabAxisDatas).forEach((key1) => {
        let axisNames = slabAxisDatas[key1];
        axisNames = sortAxisNameData(axisNames);
        if (ModelNo) {
          ModelNo += "-";
        }

        if (axisNames.length > 1) {
          slabAxisNames.push(axisNames[0]);
          slabAxisNames.push(axisNames[axisNames.length - 1]);
          // ModelNo += axisNames[0] + "-" + axisNames[axisNames.length - 1];
        } else if (axisNames.length > 0) {
          // ModelNo += axisNames[0];
          slabAxisNames.push(axisNames[0]);
        }
      });
      if (withArcAxis && arcAxisJointMatchAxisDatas.length > 0) {
        //获取弧形端点的其他轴线
        arcAxisJointMatchAxisDatas = arcAxisJointMatchAxisDatas.map(
          (item) => item.Name
        );
        arcAxisJointMatchAxisDatas = arcAxisJointMatchAxisDatas.filter(
          (item) => !slabAxisNames.includes(item)
        );
        if (arcAxisJointMatchAxisDatas.length > 0)
          slabAxisNames.push(...arcAxisJointMatchAxisDatas);
      }
      slabAxisNames = sortAxisNameData(slabAxisNames);
      // ModelNo = slabAxisNames.join("-");
      ModelNo = getModelNo(slabAxisNames);
      //如果最后一个是-，则去掉
      if (ModelNo.endsWith("-")) {
        ModelNo = ModelNo.slice(0, -1);
      }
      if (withArcAxis) {
        ModelNo += "(H)";
      }

      slab.ModelNo = ModelNo;
      saveSlabDatas.push(slab);
    }

    return saveSlabDatas;
  } catch (error) {
    console.log("autoSlabNaming error", error);
    return [];
  }
};

//计算节点所在的轴线
export const getJointAxis = (jointObj, jointDatas, axisDatas, gridDatas) => {
  try {
    if (!jointObj || !jointDatas || !axisDatas) {
      return [];
    }
    let matchAxis = [];
    for (const key in axisDatas) {
      let axis = axisDatas[key];

      if (axis.IsMainAxis < 0) {
        let ptCenter = jointDatas[axis.Jt1Guid];
        let grid = Object.values(gridDatas).filter(
          (item) => item.AxisGuid == axis.Guid
        );
        if (grid && grid.length) {
          let stArcPoint = null;
          let edArcPoint = null;
          let stAngle = 10000;
          let edAngle = -10000;
          // 获取网格的起点和终点--按照角度排序
          for (let i = 0; i < grid.length; i++) {
            let gridObj = grid[i];
            let gridjt1 = jointDatas[gridObj.Jt1Guid];
            let gridjt2 = jointDatas[gridObj.Jt2Guid];

            if (gridjt1 && gridjt2) {
              let angle1 = toDegrees(
                calculateArcAngle(
                  new THREE.Vector3(ptCenter.X, ptCenter.Y, 0),
                  new THREE.Vector3(gridjt1.X, gridjt1.Y, 0)
                )
              );
              let angle2 = toDegrees(
                calculateArcAngle(
                  new THREE.Vector3(ptCenter.X, ptCenter.Y, 0),
                  new THREE.Vector3(gridjt2.X, gridjt2.Y, 0)
                )
              );

              if (angle1 < angle2) {
                if (angle1 < stAngle) {
                  stArcPoint = gridjt1;
                  stAngle = angle1;
                }

                if (angle2 > edAngle) {
                  edArcPoint = gridjt2;
                  edAngle = angle2;
                }
              } else {
                if (angle2 < stAngle) {
                  stArcPoint = gridjt2;
                  stAngle = angle2;
                }

                if (angle1 > edAngle) {
                  edArcPoint = gridjt1;
                  edAngle = angle1;
                }
              }
            }
          }

          let ptSt = new THREE.Vector3(stArcPoint.X, stArcPoint.Y, 0);
          let ptEd = new THREE.Vector3(edArcPoint.X, edArcPoint.Y, 0);
          ptCenter = new THREE.Vector3(ptCenter.X, ptCenter.Y, 0);
          let redius = ptCenter.distanceTo(ptSt);
          const pt = new THREE.Vector3(jointObj.X, jointObj.Y, 0);

          if (ptOnArc(ptCenter, redius, ptSt, ptEd, pt) > 0) {
            matchAxis.push(axis);
          }
        }
      } else {
        const joint_1 = jointDatas[axis.Jt1Guid];
        const joint_2 = jointDatas[axis.Jt2Guid];
        if (!joint_1 || !joint_2) {
          continue;
        }

        let pt1 = new THREE.Vector3(joint_1.X, joint_1.Y, 0);
        let pt2 = new THREE.Vector3(joint_2.X, joint_2.Y, 0);
        let pt = new THREE.Vector3(jointObj.X, jointObj.Y, 0);

        if (ptOnAxis(pt1, pt2, pt) > 0) {
          matchAxis.push(axis);
        }
      }
    }

    if (matchAxis && matchAxis.length > 2) {
      //移除圆弧轴线
      matchAxis = matchAxis.filter((item) => item.IsMainAxis >= 0);
    }

    return matchAxis;
  } catch (error) {
    console.log("getJointAxis error", error);
    return [];
  }
};

//若节点上仅一条轴线，则找寻最近的，有两条及以上轴线的点
export const getNearestJointAxis = (
  jointObj,
  jointDatas,
  axisDatas,
  gridDatas,
  currAxisGuid /*已计算出的节点所在的轴线，如果与此轴线平行或共线，不做处理 */,
  gridVec /*当前网格的方向向量 */
) => {
  try {
    if (!jointObj || !jointDatas || !axisDatas) {
      return [];
    }
    let currAxisData = axisDatas[currAxisGuid];
    if (!currAxisData) return;

    let pt = new THREE.Vector3(jointObj.X, jointObj.Y, 0);

    //获取当前轴线上的网格和节点
    const currAxisGrids = Object.values(gridDatas).filter(
      (item) => item.AxisGuid == currAxisGuid
    );
    let currAxisJoints = [];
    for (let i = 0; i < currAxisGrids.length; i++) {
      const grid = currAxisGrids[i];
      if (!grid) continue;
      const joint_1 = jointDatas[grid.Jt1Guid];
      const joint_2 = jointDatas[grid.Jt2Guid];
      if (!joint_1 || !joint_2) {
        continue;
      }
      let pt1 = new THREE.Vector3(joint_1.X, joint_1.Y, 0);
      let pt2 = new THREE.Vector3(joint_2.X, joint_2.Y, 0);
      let vec1 = new THREE.Vector3(
        joint_1.X - jointObj.X,
        joint_1.Y - jointObj.Y,
        0
      ).normalize();
      let vec2 = new THREE.Vector3(
        joint_2.X - jointObj.X,
        joint_2.Y - jointObj.Y,
        0
      ).normalize();
      let dist1 = pt1.distanceTo(pt);
      let dist2 = pt2.distanceTo(pt);
      if (vec1.equals(gridVec) && dist1 > 5)
        currAxisJoints.push({ distance: dist1, joint: joint_1 });

      if (vec2.equals(gridVec) && dist2 > 5)
        currAxisJoints.push({ distance: dist2, joint: joint_2 });
    }
    //按照到当前节点的距离进行排序
    currAxisJoints.sort((a, b) => a.distance - b.distance);

    for (let i = 0; i < currAxisJoints.length; i++) {
      const joint = currAxisJoints[i].joint;
      let matchAxisData = getJointAxis(joint, jointDatas, axisDatas, gridDatas);

      matchAxisData = matchAxisData.filter(
        (item) => item.Guid != currAxisGuid && item.Name
      );
      if (matchAxisData && matchAxisData.length > 0) {
        return matchAxisData;
      }
    }
  } catch (error) {
    console.log("getNearestJointAxis error", error);
    return [];
  }
};

//获取正交的轴线
const getOrthogonalAxis = (
  matchAxis,
  jointDatas,
  originAxisLine = null, //垂直基准线,若为null,按正交取
  onlyOneAxis = false /*仅获取一条轴线 */
) => {
  if ((onlyOneAxis && matchAxis.length > 1) || matchAxis.length > 2) {
    let calMatchAxis = [];
    let otherMatchAxis = [];
    for (let ii = 0; ii < matchAxis.length; ii++) {
      const axisTmp = matchAxis[ii];
      if (axisTmp.IsMainAxis < 0) {
        otherMatchAxis.push(matchAxis);
        continue;
      }
      const axisJt1 = jointDatas[axisTmp.Jt1Guid];
      const axisJt2 = jointDatas[axisTmp.Jt2Guid];
      const jt1Point = new THREE.Vector3(axisJt1.X, axisJt1.Y, 0);
      const jt2Point = new THREE.Vector3(axisJt2.X, axisJt2.Y, 0);
      const slope =
        Math.abs(jt1Point.x - jt2Point.x) < Math.exp(-1)
          ? 9999
          : (jt2Point.y - jt1Point.y) / (jt2Point.x - jt1Point.x);
      //判断是否正交
      if (originAxisLine) {
        //判断是否垂直
        const originAxisJt1 = jointDatas[axisTmp.Jt1Guid];
        const originAxisJt2 = jointDatas[axisTmp.Jt2Guid];
        const originJt1Point = new THREE.Vector3(
          originAxisJt1.X,
          originAxisJt1.Y,
          0
        );
        const originJt2Point = new THREE.Vector3(
          originAxisJt2.X,
          originAxisJt2.Y,
          0
        );
        const direction1 = jt1Point.clone().sub(jt2Point); // 向量1
        const direction2 = originJt1Point.clone().sub(originJt2Point); // 向量2
        const dotProduct = direction1
          .clone()
          .normalize()
          .dot(direction2.clone().normalize());

        // 3. 判断是否垂直
        // 注意：由于浮点数精度问题，最好判断是否接近 0，而不是绝对等于 0
        if (Math.abs(dotProduct) < 0.0001) {
          //垂直
          calMatchAxis.push(axisTmp);
        } else {
          otherMatchAxis.push(axisTmp);
        }
      } else if (slope === 9999 || Math.abs(slope) < 0.001) {
        calMatchAxis.push(axisTmp);
      } else {
        otherMatchAxis.push(axisTmp);
      }
    }
    let count = calMatchAxis.length;
    let maxLength = onlyOneAxis ? 1 : 2;
    for (let ii = 0; count < maxLength && ii < otherMatchAxis.length; ii++) {
      calMatchAxis.push(otherMatchAxis[ii]);
      count++;
    }
    matchAxis = calMatchAxis;
  }
  return matchAxis;
};
//计算节点是否有柱子或者墙
const isHasColumnOrWall = (
  jointObj,
  columnDatas,
  gridDatas,
  wallDatas,
  axisGuid
) => {
  if (!jointObj) {
    return false;
  }
  try {
    if (columnDatas) {
      for (const key in columnDatas) {
        let column = columnDatas[key];
        if (!column) {
          continue;
        }
        if (column.JtGuid === jointObj.Guid) {
          return true;
        }
      }
    }
    if (gridDatas && wallDatas) {
      for (const key in wallDatas) {
        let wall = wallDatas[key];
        if (
          gridDatas[wall.GridGuid].Jt1Guid === jointObj.Guid ||
          gridDatas[wall.GridGuid].Jt2Guid === jointObj.Guid
        ) {
          if (gridDatas[wall.GridGuid].AxisGuid != axisGuid) {
            return true;
          }
        }
      }
    }
    return false;
  } catch (error) {
    console.log("isHasColumnOrWall error", error);
    return false;
  }
};

//轴线手动命名
export const manualAxisNaming = async () => {
  return new Promise(async (resolve, reject) => {
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    getPoint.setInputToucheType(1);

    getPoint.go(async (status1) => {
      if (status1 == 0) {
        let filter = "TEXT,MTEXT,CIRCLE,ARC,LWPOLYLINE";
        const findFilter = new MxCADResbuf();
        findFilter.AddMcDbEntityTypes(filter);

        const cadCoord = getPoint.value();
        const finId = getSelectEntity(cadCoord, findFilter);
        if (!finId) {
          resolve(null);
          return;
        }
        let axisTexts = finId.getMcDbEntity();
        if (!axisTexts) {
          resolve(null);
          return;
        }
        let axisGuid = axisTexts.getxDataString("AxisGuid").val;

        // 检查直线轴线
        for (const key in allShowAxisData) {
          let AxisDatas = allShowAxisData[key];
          for (let i = 0; i < AxisDatas.length; i++) {
            let axis = AxisDatas[i];
            if (axis.axisData.Guid === axisGuid) {
              isExistManualAxisNaming = true;
              resolve(axis);
              return;
            }
          }
        }

        // 检查弧形轴线
        for (const item of allShowArcAxisData) {
          let arc = item;
          if (arc.axisData.Guid === axisGuid) {
            isExistManualAxisNaming = true;
            resolve(arc);
            return;
          }
        }
      } else {
        // 用户取消选择，结束循环
        resolve(null);
      }
    });
  });
};

//检查是否存在相同的轴线名称
export const checkSameAxisName = () => {
  try {
    if (allShowAxisData || allShowArcAxisData) {
      //搜索是否存在相同的轴线名称
      let totalAxisDatas = {};
      for (const key in allShowAxisData) {
        let AxisDatas = allShowAxisData[key];
        for (const axis of AxisDatas) {
          let name = axis.axisData.Name;
          if (name == "") {
            continue; //空字符串不参与检查
          }
          if (totalAxisDatas[name]) {
            MxCpp.getCurrentMxCAD().showLineWeight(true);
            axis.textMcDbId1.getMcDbEntity().trueColor = new McCmColor(
              255,
              0,
              0
            );
            axis.textMcDbId1.getMcDbEntity().height = 400;
            axis.textMcDbId2.getMcDbEntity().trueColor = new McCmColor(
              255,
              0,
              0
            );
            axis.textMcDbId2.getMcDbEntity().height = 400;
            totalAxisDatas[name].textMcDbId1.getMcDbEntity().trueColor =
              new McCmColor(255, 0, 0);
            totalAxisDatas[name].textMcDbId2.getMcDbEntity().trueColor =
              new McCmColor(255, 0, 0);
            console.log("存在相同的轴线名称111", axis, totalAxisDatas[name]);
            rlAppObj.mxcadObject.updateDisplay();
            return false;
          } else {
            totalAxisDatas[name] = axis;
          }
        }
      }
      for (const key in allShowArcAxisData) {
        let AxisDatas = allShowArcAxisData[key];
        //这里AxisDatas是一个对象的值，是不对的,应该是多个值，但是不知道原本逻辑是什么，针对这个去做一个优化
        if (AxisDatas?.axisData) {
          let name = AxisDatas.axisData.Name;
          if (name != "") {
            if (totalAxisDatas[name]) {
              console.log("存在相同的轴线名称", axis, totalAxisDatas[name]);
              return false;
            } else {
              totalAxisDatas[name] = axis;
            }
          }
        } else {
          for (const axis of AxisDatas) {
            let name = axis.axisData.Name;
            if (name == "") {
              continue; //空字符串不参与检查
            }
            if (totalAxisDatas[name]) {
              console.log("存在相同的轴线名称", axis, totalAxisDatas[name]);
              return false;
            } else {
              totalAxisDatas[name] = axis;
            }
          }
        }
      }
    }
    return true;
  } catch (error) {
    console.log("checkSameAxisName error", error);
    return false;
  }
};

//结束自动命名
export const endAutoNaming = async () => {
  try {
    showFullScreenLoading("正在布置构件命名...");
    if (isExistManualAxisNaming) {
      await autoAllFloorAxisNaming(allShowAxisData);
      await autoAllFloorArcAxisNaming(allShowArcAxisData);
    }

    await autoComponentNaming();
    isExistManualAxisNaming = false;
    tryHideFullScreenLoading();
    return true;
  } catch (error) {
    console.log("endAutoNaming error", error);
    return false;
  }
};

/**
 * 判断字符串中是否仅包含数字，忽略特殊符号
 * @param {string} str - 要检查的字符串
 * @returns {boolean} - 如果字符串中仅包含数字则返回true，否则返回false
 */
const isOnlyNumbers = (str) => {
  if (typeof str !== "string") return false;
  // 去掉所有“符号/标点/空白”，保留字母和数字用于判断
  const cleaned = str.replace(/[\p{P}\p{S}\s]/gu, "");
  return cleaned.length > 0 && /^[0-9]+$/.test(cleaned);
};

//对轴线数据进行排序
const sortAxisNameData = (axisDatas) => {
  try {
    // 首先过滤掉空值
    const filteredData = axisDatas.filter((value) => value !== "");

    // 对非空值进行排序
    return filteredData.sort((a, b) => {
      // 新增特殊规则：1/B在B的后面
      if (/^1\/[A-Z0-9]+$/.test(a) && b === a.split("/")[1]) {
        return 1; // a(1/B)排在b(B)后面
      }
      if (/^1\/[A-Z0-9]+$/.test(b) && a === b.split("/")[1]) {
        return -1; // b(1/B)排在a(B)后面
      }

      // 判断是否都是分数形式
      const isAFraction = a.includes("/");
      const isBFraction = b.includes("/");
      if (isAFraction && isBFraction) {
        // 分数形式，分子/分母
        const [aNumer, aDenom] = a.split("/");
        const [bNumer, bDenom] = b.split("/");
        // 先比较分母
        if (aDenom !== bDenom) {
          // 分母用原有字母+数字排序逻辑
          const aMatch = aDenom.match(/^([A-Z]*)(\d*)$/);
          const bMatch = bDenom.match(/^([A-Z]*)(\d*)$/);
          if (!aMatch || !bMatch) {
            const aCode = aDenom.charCodeAt(aDenom.length - 1);
            const bCode = bDenom.charCodeAt(bDenom.length - 1);
            return aCode - bCode;
          }
          const [, aLetter = "", aNumber = ""] = aMatch;
          const [, bLetter = "", bNumber = ""] = bMatch;
          if (aLetter !== bLetter) {
            return aLetter.localeCompare(bLetter);
          }
          const aNum = aNumber ? parseInt(aNumber) : 0;
          const bNum = bNumber ? parseInt(bNumber) : 0;
          return aNum - bNum;
        } else {
          // 分母相同，比较分子（数字优先，数字小的在前）
          const aNum = isNaN(Number(aNumer)) ? aNumer : Number(aNumer);
          const bNum = isNaN(Number(bNumer)) ? bNumer : Number(bNumer);
          if (typeof aNum === "number" && typeof bNum === "number") {
            return aNum - bNum;
          } else {
            return String(aNum).localeCompare(String(bNum));
          }
        }
      }
      // 不是分数形式，原有逻辑
      const aCompare = isAFraction ? a.split("/")[1] : a;
      const bCompare = isBFraction ? b.split("/")[1] : b;
      const aMatch = aCompare.match(/^([A-Z]*)(\d*)$/);
      const bMatch = bCompare.match(/^([A-Z]*)(\d*)$/);
      if (!aMatch || !bMatch) {
        const aCode = aCompare.charCodeAt(aCompare.length - 1);
        const bCode = bCompare.charCodeAt(bCompare.length - 1);
        if (aCode === bCode) {
          return isAFraction ? 1 : -1;
        }
        return aCode - bCode;
      }
      const [, aLetter = "", aNumber = ""] = aMatch;
      const [, bLetter = "", bNumber = ""] = bMatch;
      if (aLetter !== bLetter) {
        return aLetter.localeCompare(bLetter);
      }
      const aNum = aNumber ? parseInt(aNumber) : 0;
      const bNum = bNumber ? parseInt(bNumber) : 0;
      return aNum - bNum;
    });
  } catch (error) {
    console.log("sortAxisNameData error", error);
    return [];
  }
};

//对共线网格排序
const sortSameAxisGrids = (
  stJointGuid,
  edJointGuid,
  jointDatas,
  gridDatas,
  sortGrids
) => {
  if (!jointDatas[stJointGuid] || !jointDatas[edJointGuid]) {
    return sortGrids;
  }
  const ptSt = new THREE.Vector3(
    jointDatas[stJointGuid].X,
    jointDatas[stJointGuid].Y,
    0
  );
  const ptEd = new THREE.Vector3(
    jointDatas[edJointGuid].X,
    jointDatas[edJointGuid].Y,
    0
  );
  const ptMid = ptSt.clone().add(ptEd).multiplyScalar(0.5);
  sortGrids = sortGrids.sort((a, b) => {
    const ptA_St = new THREE.Vector3(
      jointDatas[gridDatas[a.GridGuid].Jt1Guid].X,
      jointDatas[gridDatas[a.GridGuid].Jt1Guid].Y,
      0
    );
    const ptA_Ed = new THREE.Vector3(
      jointDatas[gridDatas[a.GridGuid].Jt2Guid].X,
      jointDatas[gridDatas[a.GridGuid].Jt2Guid].Y,
      0
    );
    const ptA_Mid = ptA_St.clone().add(ptA_Ed).multiplyScalar(0.5);
    const ptB_St = new THREE.Vector3(
      jointDatas[gridDatas[b.GridGuid].Jt1Guid].X,
      jointDatas[gridDatas[b.GridGuid].Jt1Guid].Y,
      0
    );
    const ptB_Ed = new THREE.Vector3(
      jointDatas[gridDatas[b.GridGuid].Jt2Guid].X,
      jointDatas[gridDatas[b.GridGuid].Jt2Guid].Y,
      0
    );
    const ptB_Mid = ptB_St.clone().add(ptB_Ed).multiplyScalar(0.5);
    return ptA_Mid.distanceTo(ptSt) - ptB_Mid.distanceTo(ptSt);
  });
  return sortGrids;
};

//判断梁的截面是否相同
const isSameBeamSect = (sect1, sect2) => {
  if (sect1.Guid === sect2.Guid) {
    return true;
  }

  if (sect1.Mat !== sect2.Mat) {
    return false;
  }
  if (sect1.Kind !== sect2.Kind) {
    return false;
  }
  let ShapeVal1 = sect1.ShapeVal.split(",");
  let ShapeVal2 = sect2.ShapeVal.split(",");
  if (ShapeVal1.length !== ShapeVal2.length) {
    return false;
  }

  if (sect1.Kind === 21) {
    //矩形变截面
    return true;
  }

  //判断ShapeVal内部数据是否完全一致
  for (let i = 0; i < ShapeVal1.length; i++) {
    if (ShapeVal1[i] !== ShapeVal2[i]) {
      return false;
    }
  }

  return true;
};

//判断当前梁的截面是否矮于其他梁的截面
const isLowerBeamSect = (currBeam, otherBeam) => {
  if (currBeam.Guid === otherBeam.Guid) {
    return false;
  }
  //如果材质不同，则当前梁矮于其他梁
  if (currBeam.Mat !== otherBeam.Mat) {
    return true;
  }
  //如果截面类型不同，则当前梁矮于其他梁
  if (currBeam.Kind !== otherBeam.Kind) {
    return true;
  }

  let ShapeVal1 = currBeam.ShapeVal.split(",");
  let ShapeVal2 = otherBeam.ShapeVal.split(",");
  if (ShapeVal1.length !== ShapeVal2.length) {
    return true;
  }

  //矩形截面
  if (currBeam.Kind === 1 && ShapeVal1.length == 5) {
    if (Number(ShapeVal1[2]) < Number(ShapeVal2[2])) {
      return true;
    }

    return false;
  } else {
    //判断ShapeVal内部数据是否完全一致
    for (let i = 0; i < ShapeVal1.length; i++) {
      if (ShapeVal1[i] !== ShapeVal2[i]) {
        return true;
      }
    }
    return false;
  }
};

//判断当前次梁的刚度是否小于其他次梁的刚度
const isLowerSubBeamSect = (currBeamSect, otherBeamSect) => {
  if (currBeamSect.Guid === otherBeamSect.Guid) {
    return false;
  }
  //如果材质不同，则当前梁矮于其他梁
  if (currBeamSect.Mat !== otherBeamSect.Mat) {
    return true;
  }

  //如果截面类型不同，则当前梁矮于其他梁
  if (currBeamSect.Kind !== otherBeamSect.Kind) {
    return true;
  }
  let ShapeVal1 = currBeamSect.ShapeVal.split(",");
  let ShapeVal2 = otherBeamSect.ShapeVal.split(",");
  if (ShapeVal1.length !== ShapeVal2.length) {
    return true;
  }

  //矩形截面
  if (currBeamSect.Kind === 1 && ShapeVal1.length == 5) {
    let currBeamB = Number(ShapeVal1[1]);
    let currBeamH = Number(ShapeVal1[2]);

    let otherBeamB = Number(ShapeVal2[1]);
    let otherBeamH = Number(ShapeVal2[2]);
    if (
      currBeamB * currBeamH * currBeamH * currBeamH <
      otherBeamB * otherBeamH * otherBeamH * otherBeamH
    ) {
      return true;
    }

    return false;
  } else {
    //判断ShapeVal内部数据是否完全一致
    for (let i = 0; i < ShapeVal1.length; i++) {
      if (ShapeVal1[i] !== ShapeVal2[i]) {
        return true;
      }
    }
    return false;
  }
};
//判断点是否在直线或者直线的延长线上
function ptOnAxis(pt1, pt2, pt) {
  if (ptOnLine(pt1, pt2, pt) > 0) {
    return 1;
  }
  //计算pt与pt1的斜率
  const k1 =
    Math.abs(pt1.x - pt.x) > 0.01
      ? (pt1.y - pt.y) / (pt1.x - pt.x)
      : Math.abs(pt1.y - pt.y) < 0.01
      ? 0
      : 9999;
  //计算pt与pt2的斜率
  const k2 =
    Math.abs(pt2.x - pt.x) > 0.01
      ? (pt2.y - pt.y) / (pt2.x - pt.x)
      : Math.abs(pt2.y - pt.y) < 0.01
      ? 0
      : 9999;

  //判断斜率是否相同
  if (Math.abs(k1 - k2) < 0.001) {
    return 1;
  }
  return 0;

  //pt到pt1的方向向量
  const vec1 = new THREE.Vector3(pt1.x - pt.x, pt1.y - pt.y, 0);
  //pt到pt2的方向向量
  const vec2 = new THREE.Vector3(pt2.x - pt.x, pt2.y - pt.y, 0);
  //判断两个方向向量是否平行
  if (vec1.cross(vec2).length() === 0) {
    return 1;
  }
  return 0;
}

//获取直线方程
function getLineEquation(x1, y1, x2, y2) {
  const A = y2 - y1;
  const B = x1 - x2;
  const C = x2 * y1 - x1 * y2;
  return { A, B, C };
}

//更新次梁的构件号,subBeamDatas==合并的次梁集合，flrGuid==楼层guid
export const updateSubBeamModelNo = async (subBeamDatas, flrGuid) => {
  try {
    if (!subBeamDatas || subBeamDatas.length === 0) {
      return;
    }
    let floorData = await getrlStdFlr(flrGuid);
    if (!floorData) {
      return;
    }
    let axisDatas = floorData["rlAxis"];
    let gridDatas = floorData["rlGrid"];
    let jointDatas = floorData["rlJoint"];
    if (!axisDatas || !gridDatas || !jointDatas) {
      return;
    }
    // console.log("44444", subBeamDatas);
    let currAxis = null; //当前轴线
    let currJointDatas = []; //当前次梁所在的网格上的节点集合
    for (const subBeam of subBeamDatas) {
      if (currAxis == null) {
        currAxis = subBeam.m_gridData.m_Axis;
      } else if (subBeam.m_gridData.m_Axis.Guid !== currAxis.Guid) {
        return false; //轴线不一致,不能合并一组计算构件号
      }
      let pt1 = new THREE.Vector3(...subBeam.m_gridData.m_stJoint.m_pt);
      let pt2 = new THREE.Vector3(...subBeam.m_gridData.m_edJoint.m_pt);
      currJointDatas.push({ obj: subBeam.m_gridData.m_stJoint, pt: pt1 });
      currJointDatas.push({ obj: subBeam.m_gridData.m_edJoint, pt: pt2 });
    }
    currJointDatas.sort(function (a, b) {
      if (a.pt.x !== b.pt.x) return a.pt.x - b.pt.x;
      if (a.pt.y !== b.pt.y) return a.pt.y - b.pt.y;
      return a.pt.z - b.pt.z;
    });
    // console.log("currJointDatas:", currJointDatas[0].obj.getDataBase());

    let stJointAxis = getJointAxis(
      currJointDatas[0].obj.getDataBase(),
      jointDatas,
      axisDatas,
      gridDatas
    );

    if (stJointAxis.length > 0) {
      stJointAxis = stJointAxis.filter((item) => item.Guid !== currAxis.Guid);
    }
    let edJointAxis = getJointAxis(
      currJointDatas[currJointDatas.length - 1].obj.getDataBase(),
      jointDatas,
      axisDatas,
      gridDatas
    );
    if (edJointAxis.length > 0) {
      edJointAxis = edJointAxis.filter((item) => item.Guid !== currAxis.Guid);
    }
    if (stJointAxis.length > 0 && edJointAxis.length > 0) {
      let axisNameDatas = [];
      axisNameDatas.push(stJointAxis[0].Name);
      axisNameDatas.push(edJointAxis[0].Name);

      axisNameDatas.push(currAxis.Name);
      axisNameDatas = sortAxisNameData(axisNameDatas);
      // let ModelNo = axisNameDatas.join("-");
      let ModelNo = getModelNo(axisNameDatas);

      // console.log("ModelNo:", ModelNo);

      for (let i = 0; i < subBeamDatas.length; i++) {
        subBeamDatas[i].ModelNo = ModelNo;
      }
      return subBeamDatas;
    }
    return null;
  } catch (error) {
    console.log("updateSubBeamModelNo error", error);
  }
};

//对共线的顶点进行排序
export const sortCollinearPoints = (points) => {
  if (points.length <= 1) {
    return points;
  }

  //定基准方向
  const dirOrigin = new THREE.Vector3()
    .subVectors(points[0], points[1])
    .normalize();
  dirOrigin.x = parseFloat(dirOrigin.x.toFixed(1));
  dirOrigin.y = parseFloat(dirOrigin.y.toFixed(1));

  // 计算所有点之间的距离
  const sortAxisData = [];
  for (let i = 1; i < points.length; i++) {
    const dir = new THREE.Vector3()
      .subVectors(points[0], points[i])
      .normalize();
    dir.x = parseFloat(dir.x.toFixed(1));
    dir.y = parseFloat(dir.y.toFixed(1));
    let distance = points[0].distanceTo(points[i]);
    //计算方向向量点积
    const dotProduct = dirOrigin.dot(dir);
    //如果点积大于0，则距离为负
    if (dotProduct > 0) {
      //distance = -distance;
    } else if (dotProduct < 0) {
      distance = -distance;
    }
    // 将 distance 和 itemTmp 添加到数组中
    sortAxisData.push({ distance, pt: points[i] });
  }

  // 根据距离排序
  sortAxisData.sort((a, b) => a.distance - b.distance);

  // 返回排序后的点
  return sortAxisData.map((item) => item.pt);
};
